import Swal2 from "sweetalert2";
import { useState, useMemo, useEffect, useContext } from "react";
import { WalletContext } from "../WalletContext";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Modal } from "react-bootstrap";
// import name from "./../assets/successGroup.png";
import myplanlocation from "./../assets/myplanlocation.png";
import myplancalender from "./../assets/myplancalender.png";
import IsNonVeg from "./../assets/isVeg=no.svg";
import IsVeg from "./../assets/isVeg=yes.svg";
import myplancancelicon from "./../assets/myplancancelicon.png";
// import myplandrop from "./../assets/myplandrop.png";
import myplanseparator from "./../assets/myplanseparator.png";
import myplanskip from "./../assets/myplanskip.png";
import myplancancel3 from "./../assets/myplancancelicon.png";
import myplancancel2 from "./../assets/mycancel.png";
// import myplanblackedit from "./../assets/myplanblackedit.png";
import BottomNav from "./BottomNav";
import "../Styles/MyPlan.css";
// import "../Styles/Checkout.css"
import { toast } from "react-toastify";
import pending from "./../assets/pending.png";
import success from "./../assets/success-green.png";
// import discount from "./../assets/discount.png";
import myplancancel from "./../assets/myplancancel.png";
import "./../Styles/Normal.css";
import orderhistoryicon from "./../assets/orderhistory.png";
import LocationModal2 from "./LocationModal2";
import AddMoreToSlotModal from "./AddMoreToSlotModal";

import "../Styles/AddMoreToSlotModal.css";
import checkCircle from "../assets/check_circle.png";

const formatDate = (isoString) => {
  const d = new Date(isoString);
  return `${d.getDate().toString().padStart(2, "0")} ${d.toLocaleString(
    "en-US",
    { month: "short" },
  )}`;
};

const formatDay = (isoString) => {
  return new Date(isoString)
    .toLocaleString("en-US", { weekday: "short" })
    .toUpperCase();
};

const ViewPlanModal = ({
  isOpen,
  onClose,
  plan,
  userId,
  onPlanUpdated,
  handlePayPlan,
  handleTrackOrder,
  address,
}) => {
  // console.log("plans are", plan);
  const user = JSON.parse(localStorage.getItem("user"));

  const navigate = useNavigate();
  const [localPlan, setLocalPlan] = useState(plan);
  // console.log("Viewing plan:", plan);

  const [deliveryNotes, setDeliveryNotes] = useState(plan.deliveryNotes || "");
  const [isProcessing, setIsProcessing] = useState(false);
  useEffect(() => {
    setLocalPlan(plan);
    // setDeliveryNotes(plan.deliveryNotes || "");
  }, [plan]);

  // Only allow editing if before cutoff (10am Lunch, 5pm Dinner)
  function getCutoffTime(deliveryDate, session) {
    const cutoff = new Date(deliveryDate);
    if (session === "Lunch") {
      cutoff.setHours(10, 0, 0, 0);
    } else {
      cutoff.setHours(17, 0, 0, 0);
    }
    return cutoff;
  }

  const now = new Date();
  const cutoffTime = getCutoffTime(localPlan.deliveryDate, localPlan.session);
  const isEditable = localPlan.status === "Pending Payment" && now < cutoffTime;

  async function changeQuantity(foodItemId, delta) {
    if (!isEditable) return;

    const product = localPlan.products.find(
      (p) => p.foodItemId === foodItemId || p.foodItemId?._id === foodItemId,
    );
    if (!product) return;

    const newQty = (product.quantity || 0) + delta;
    if (newQty < 0) return;

    try {
      const res = await axios.post(
        "https://dailydish.in/api/user/plan/update-product",
        {
          planId: localPlan._id,
          foodItemId:
            typeof product.foodItemId === "string"
              ? product.foodItemId
              : product.foodItemId?._id,
          quantity: newQty,
        },
      );

      if (res.data.success) {
        if (
          !res.data.data ||
          res.data.message === "Plan removed as it is empty"
        ) {
          Swal2.fire({
            toast: true,
            position: "bottom",
            showConfirmButton: false,
            timer: 2500,
            timerProgressBar: true,
            html: `
          <div class="myplans-toast-content">
            <img src="${checkCircle}" alt="Success" class="myplans-toast-check" />
            <div class="myplans-toast-text">
              <div class="myplans-toast-title">Plan Removed.</div>
              <div class="myplans-toast-subtitle">Plan removed as it is empty</div>
            </div>
          </div>
        `,
            customClass: {
              popup: "myplans-custom-toast",
              htmlContainer: "myplans-toast-html",
            },
            didOpen: () => {
              // Position above bottom nav
              const toast = document.querySelector(".myplans-custom-toast");
              if (toast) {
                toast.style.bottom = "90px"; // Position above bottom nav
                toast.style.left = "50%";
                toast.style.transform = "translateX(-50%)";
                toast.style.position = "fixed";
              }
            },
          });
          onClose(); // Close the modal
          if (onPlanUpdated) onPlanUpdated(); // Refresh parent list
          return;
        }
        const updatedPlan = res.data.data;
        setLocalPlan(updatedPlan);
        // also inform parent to refresh main list if needed
        onPlanUpdated && onPlanUpdated();
      } else {
        alert(res.data.error || "Failed to update quantity");
      }
    } catch (e) {
      alert(e.response?.data?.error || "Failed to update quantity");
    }
  }
  // console.log(localPlan);
  // Find this function in MyPlan.jsx
  const handleAddMore = async () => {
    await handleSetPrimary(localPlan.addressId);
    navigate("/", {
      state: {
        targetDate: localPlan.deliveryDate,
        targetSession: localPlan.session,
      },
    });
  };

  const handleSetPrimary = async (addressId) => {
    try {
      if (!userId) {
        throw new Error("Customer ID not found. Please login again.");
      }
      const response = await axios.patch(
        `https://dailydish.in/api/User/customers/${userId}/addresses/${addressId}/primary`,
      );
      alert("Setting primary address...");

      // Optimistic cache update: update local cached addresses so UI reflects change immediately
      try {
        const cacheKey = `addresses_${userId}`;
        const cacheTsKey = `addresses_timestamp_${userId}`;

        const cachedStr = localStorage.getItem(cacheKey);
        if (cachedStr) {
          const cached = JSON.parse(cachedStr);
          // update primary id
          cached.primaryAddress = addressId;

          // If we have the addresses array, try to locate the full address object
          const fullAddr = Array.isArray(cached.addresses)
            ? cached.addresses.find((a) => a._id === addressId) || null
            : null;

          // persist updated cache
          localStorage.setItem(cacheKey, JSON.stringify(cached));
          localStorage.setItem(cacheTsKey, Date.now().toString());

          // store a convenient `primaryAddress` entry (other parts of app use this)
          if (fullAddr) {
            localStorage.setItem("primaryAddress", JSON.stringify(fullAddr));
          } else if (response.data?.primaryAddress) {
            localStorage.setItem(
              "primaryAddress",
              JSON.stringify(response.data.primaryAddress),
            );
          } else {
            // fallback: store id only
            localStorage.setItem("primaryAddress", JSON.stringify(addressId));
          }
        } else {
          // no cache present — still set timestamp and primaryAddress from response if available
          localStorage.setItem(
            `addresses_timestamp_${userId}`,
            Date.now().toString(),
          );
          if (response.data?.primaryAddress) {
            localStorage.setItem(
              "primaryAddress",
              JSON.stringify(response.data.primaryAddress),
            );
          } else {
            localStorage.setItem("primaryAddress", JSON.stringify(addressId));
          }
        }
      } catch (cacheErr) {
        console.warn("Failed to update address cache:", cacheErr);
      }

      // console.log("Primary address set successfully!", "success");
    } catch (error) {
      console.error("Error setting primary address:", error);
      console.log(error.message || "Failed to set primary address", "danger");
    }
  };

  const [isBillingOpen, setIsBillingOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showLocationModal, setShowLocationModal] = useState(false);
  const [showAddMoreModal, setShowAddMoreModal] = useState(false);
  // Wallet selection state (use WalletContext for live data)
  const { wallet } = useContext(WalletContext);
  const walletBalance = wallet?.balance || 0;
  const [useWallet, setUseWallet] = useState(false);
  // Compute max wallet deduction (same as Checkout)
  const maxWalletDeduction = Math.max(
    0,
    Math.min(walletBalance, localPlan.payableAmount || 0),
  );
  const [walletDeduction, setWalletDeduction] = useState(0);
  // Update wallet deduction when useWallet toggles or wallet/plan changes
  useEffect(() => {
    if (useWallet) {
      setWalletDeduction(maxWalletDeduction);
    } else {
      setWalletDeduction(0);
    }
  }, [useWallet, walletBalance, localPlan.slotTotalAmount]);
  // Payable amount after wallet deduction
  const payableAmount = Math.max(
    0,
    (localPlan.payableAmount || 0) - walletDeduction,
  );

  if (!isOpen || !localPlan) return null;

  const toggleBillingDetails = () => setIsBillingOpen((p) => !p);

  // Payment/editing allowed only before cutoff
  const isUnpaidEditable =
    localPlan.status === "Pending Payment" && now < cutoffTime;
  const isPaidEditable = localPlan.status === "Confirmed" && now < cutoffTime;
  const isPaidLocked = localPlan.status === "Confirmed" && now >= cutoffTime;
  const isConfirmed = localPlan.status === "Confirmed";
  const getTimeRemainingToCutoff = () => {
    const diff = cutoffTime - now;
    if (diff <= 0) return { days: 0, hours: 0, mins: 0, isExpired: true };
    const totalMinutes = Math.floor(diff / (1000 * 60));
    const days = Math.floor(totalMinutes / (60 * 24));
    const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
    const mins = totalMinutes % 60;
    return { days, hours, mins, isExpired: false };
  };
  const { days, hours, mins, isExpired } = getTimeRemainingToCutoff();
  const handleAddressChange = async () => {
    try {
      // await axios.patch(`https://dailydish.in/api/User/customers/${userId}/addresses/${localPlan.addressId}/primary`)
      setShowLocationModal(true);
    } catch (error) {
      Swal2.fire("Error", "Unable to Change Address", "error");
    }
  };

  const handleAddressSelected = async (address) => {
    try {
      setLoading(true);
      // Call backend to update plan address
      const response = await axios.post(
        "https://dailydish.in/api/user/plan/update-address",
        {
          planId: localPlan._id,
          userId,
          addressId: address._id,
        },
      );

      if (response.data.success) {
        // Update local plan with new address data
        const updatedPlan = response.data.data;
        setLocalPlan(updatedPlan);
        setShowLocationModal(false);
        toast.success("Address updated successfully!");
        onPlanUpdated && onPlanUpdated();
      }
    } catch (err) {
      console.error("Error updating address:", err);
      toast.error(err?.response?.data?.error || "Failed to update address");
    } finally {
      setLoading(false);
    }
  };

  const handleSkipOrCancel = async () => {
    try {
      setLoading(true);
      await axios.post("https://dailydish.in/api/user/plan/skip-cancel", {
        planId: plan._id,
        userId,
      });

      // Show success toast with same styling as "move to my plan" toast
      Swal2.fire({
        toast: true,
        position: "bottom",
        showConfirmButton: false,
        timer: 2500,
        timerProgressBar: true,
        html: `
          <div class="myplans-toast-content">
            <img src="${checkCircle}" alt="Success" class="myplans-toast-check" />
            <div class="myplans-toast-text">
              <div class="myplans-toast-title">Plan skipped.</div>
              <div class="myplans-toast-subtitle">Removing from your upcoming list</div>
            </div>
          </div>
        `,
        customClass: {
          popup: "myplans-custom-toast",
          htmlContainer: "myplans-toast-html",
        },
        didOpen: () => {
          // Position above bottom nav
          const toast = document.querySelector(".myplans-custom-toast");
          if (toast) {
            toast.style.bottom = "90px"; // Position above bottom nav
            toast.style.left = "50%";
            toast.style.transform = "translateX(-50%)";
            toast.style.position = "fixed";
          }
        },
      });

      onPlanUpdated && onPlanUpdated();
      onClose();
    } catch (err) {
      alert(err?.response?.data?.error || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  // Payment handler: if payableAmount is 0, skip gateway and call /create-from-plan
  // const handlePay = async () => {
  //   if (payableAmount === 0) {
  //     // Directly create order from plan (like Checkout)
  //     try {
  //       setLoading(true);
  //       const res = await axios.post("/api/user/myplan/create-from-plan", {
  //         userId,
  //         planId: localPlan._id,
  //         discountWallet: walletDeduction,
  //       });
  //       setLoading(false);
  //       if (res.data.success) {
  //         toast.success("Order placed successfully!");
  //         onPlanUpdated && onPlanUpdated();
  //         onClose();
  //       } else {
  //         toast.error(res.data.message || "Order failed");
  //       }
  //     } catch (err) {
  //       setLoading(false);
  //       toast.error("Order failed");
  //     }
  //   } else {
  //     // Proceed to payment gateway as usual
  //     onPlanUpdated &&
  //       onPlanUpdated("pay", { ...plan, discountWallet: walletDeduction });
  //   }
  // };

  return (
    <div
      className="plan-modal-overlay"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby="plan-modal-title"
    >
      <div className="close-button-container">
        <button
          onClick={onClose}
          className="close-modal-btn"
          tabIndex={0}
          aria-label="Close modal"
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              onClose();
            }
          }}
        >
          <img src={myplancancel2} alt="" style={{ width: 39, height: 39 }} />
        </button>
      </div>

      {/* <div className="view-plan-top">
        <div className="view-plan-time">
          {formatDate(localPlan.deliveryDate)}{" "}
          {formatDay(localPlan.deliveryDate)}
        </div>
        <div className="reminder-banner">
          {localPlan.status === "Pending Payment" && isBeforeDeadline && (
            <>
              Confirm plan within {days} days, {hours} hours
            </>
          )}
        </div>
      </div> */}
      <div
        className="plan-modal-content"
        onClick={(e) => {
          e.stopPropagation();
        }}
        // style={
        //   localPlan.status === "Pending Payment" && isBeforeDeadline
        //     ? {
        //         borderTopRightRadius: 0,
        //       }
        //     : {}
        // }
      >
        {/* Header */}
        <div className="modal-header-section">
          <div className="plan-header">
            <div className="plan-session-info">
              <h3 className="session-title" id="plan-modal-title">
                {localPlan.session}
              </h3>
              <div className="delivery-time-text">
                Arrives fresh between{" "}
                {localPlan?.addressType === "School"
                  ? "12:00 to 12:15 PM"
                  : localPlan?.session === "Lunch"
                    ? "12:00 to 01:00 PM"
                    : "07:30 to 08:30 PM"}
              </div>
            </div>

            <div className="upcoming-date-badge2">
              <div className="date-column2">
                <div className="date-day2">
                  {new Date(plan.deliveryDate).toLocaleDateString("en-US", {
                    day: "numeric",
                  })}
                </div>
                <div className="date-month2">
                  {new Date(plan.deliveryDate).toLocaleDateString("en-US", {
                    month: "short",
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Products list */}
        <div className="checkoutcontainer">
          <div className="cart-container">
            <div className="plans-item-section">
              <div className="plans-item-content">
                {/* Header row */}
                {/* <div className="cart-header"> */}
                {/* <div className="header-content"> */}
                <div className="plan-item-header">
                  <div className="header-title">
                    <div className="title-text">
                      <div className="title-label">From Kitchen</div>
                    </div>
                  </div>
                  <div className="header-right">
                    <div className="qty-header">
                      <div className="qty-text">
                        <div className="title-label">Qty</div>
                      </div>
                    </div>
                    <div className="price-text">
                      <div className="title-label">Price</div>
                    </div>
                  </div>
                </div>
                {/* </div> */}
                {/* </div> */}

                {(localPlan.products || []).map((product, index) => (
                  <div className="plan-item" key={product._id || index}>
                    {/* <div className="plan-item-content"> */}
                    <div className="plan-item-details">
                      <div className="plan-left-left">
                        {index + 1}.
                        <img
                          src={
                            product?.foodCategory === "Veg" ? IsVeg : IsNonVeg
                          }
                          alt="type"
                          className="indicator-icon"
                        />
                      </div>
                      <div className="plan-left-right">
                        <div className="plan-item-name">
                          {/* <div className="item-name-text"> */}
                          {product.foodName}
                          {/* </div> */}
                        </div>
                        {/* <div className="item-tags"> */}
                        <div className="portion-tag">
                          {/* <div className="portion-text"> */}
                          <div className="plan-portion-label">
                            {product.quantity} Portion
                            {product.quantity > 1 ? "s" : ""}
                          </div>
                          {/* </div> */}
                        </div>
                      </div>
                      {/* </div> */}
                    </div>
                    <div className="plan-item-controls">
                      {/* qty +/- disabled for now; can be wired to updatePlanProduct API */}
                      <div className="quantity-control">
                        <div
                          className={`${
                            !isEditable && "disabled"
                          } quantity-control`}
                        >
                          <button
                            className="quantity-btn"
                            disabled={!isEditable}
                            tabIndex={isEditable ? 0 : -1}
                            aria-label={`Decrease quantity of ${product.foodName}`}
                            onClick={() =>
                              changeQuantity(
                                product.foodItemId?.toString?.() ||
                                  product.foodItemId,
                                -1,
                              )
                            }
                            onKeyDown={(e) => {
                              if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                changeQuantity(
                                  product.foodItemId?.toString?.() ||
                                    product.foodItemId,
                                  -1,
                                );
                              }
                            }}
                          >
                            <div className="btn-text">-</div>
                          </button>
                          <div className="quantity-display">
                            <div className="quantity-text">
                              {product.quantity}
                            </div>
                          </div>
                          <button
                            className="quantity-btn"
                            disabled={!isEditable}
                            tabIndex={isEditable ? 0 : -1}
                            aria-label={`Increase quantity of ${product.foodName}`}
                            onClick={() =>
                              changeQuantity(
                                product.foodItemId?.toString?.() ||
                                  product.foodItemId,
                                1,
                              )
                            }
                            onKeyDown={(e) => {
                              if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                changeQuantity(
                                  product.foodItemId?.toString?.() ||
                                    product.foodItemId,
                                  1,
                                );
                              }
                            }}
                          >
                            <div className="btn-text">+</div>
                          </button>
                        </div>
                      </div>
                      <div className="price-container vertical">
                        {/* Always show preorder price, as only preorder is allowed */}
                        {product.hubTotalPrice?.toFixed(0) <
                          product.totalPrice?.toFixed(0) && (
                          <div className="plan-actual-price">
                            <div className="plan-current-currency">
                              <div className="current-currency-text">₹</div>
                            </div>
                            <div className="plan-hub-amount">
                              <div className="hub-amount-text">
                                {product.hubTotalPrice?.toFixed(0)}
                              </div>
                            </div>
                          </div>
                        )}

                        <div className="plan-current-price">
                          <div className="plan-current-currency">
                            <div className="current-currency-text"></div>
                          </div>
                          <div className="plan-current-amount-text">
                            <div>₹{product.totalPrice?.toFixed(0)}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* </div> */}
                  </div>
                ))}

                {/* Total row */}
                <div className="plan-cart-footer">
                  {isEditable && (
                    <div className="plan-add-more-section">
                      <button
                        className="plan-add-more-btn"
                        tabIndex={0}
                        aria-label="Add more items to plan"
                        onClick={() => setShowAddMoreModal(true)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            setShowAddMoreModal(true);
                          }
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="26"
                          height="26"
                          viewBox="0 0 18 18"
                          fill="none"
                          aria-hidden="true"
                        >
                          <path
                            d="M9 3C12.3082 3 15 5.69175 15 9C15 12.3082 12.3082 15 9 15C5.69175 15 3 12.3082 3 9C3 5.69175 5.69175 3 9 3ZM9 1.5C4.85775 1.5 1.5 4.85775 1.5 9C1.5 13.1423 4.85775 16.5 9 16.5C13.1423 16.5 16.5 13.1423 16.5 9C16.5 4.85775 13.1423 1.5 9 1.5ZM12.75 8.25H9.75V5.25H8.25V8.25H5.25V9.75H8.25V12.75H9.75V9.75H12.75V8.25Z"
                            fill="#6b8e23"
                          />
                        </svg>
                        Add More
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Delivery Details */}

            <div
              style={{
                fontWeight: 500,
                color: "#212121",
                paddingBottom: 8,
                paddingLeft: 8,
                fontSize: 20,
                letterSpacing: "-1px",
              }}
            >
              Delivery Details
            </div>

            <div className="plan-delivery-details-container">
              {/* --- Address Row --- */}
              <div className="plan-delivery-details-row">
                {/* Icon */}
                <div className="delivery-icon-wrapper">
                  <img
                    style={{
                      filter:
                        "invert(40%) sepia(88%) saturate(390%) hue-rotate(36deg) brightness(94%) contrast(89%)",
                    }}
                    // You might need to import this image or check if the path is correct
                    src="/Assets/selectlocation.svg"
                    alt="Location"
                    className="delivery-icon"
                  />
                </div>

                {/* Content */}
                <div className="plan-delivery-content-wrapper">
                  {/* 1. Location Name (e.g. Work, Home, School Name) */}
                  <p
                    className="text-truncate plan-location-name"
                    style={{ maxWidth: "220px", color: "black" }}
                    title={
                      localPlan?.addressType === "Home"
                        ? localPlan?.homeName || "Home"
                        : localPlan?.addressType === "PG"
                          ? localPlan?.apartmentName || "PG"
                          : localPlan?.addressType === "School"
                            ? localPlan?.schoolName || "School"
                            : localPlan?.addressType === "Work" ||
                                localPlan?.addressType === "corporate"
                              ? localPlan?.companyName
                              : localPlan?.addressType || "Delivery Location"
                    }
                  >
                    {localPlan?.addressType === "Home"
                      ? localPlan?.homeName || "Home"
                      : localPlan?.addressType === "PG"
                        ? localPlan?.apartmentName || "PG"
                        : localPlan?.addressType === "School"
                          ? localPlan?.schoolName || "School"
                          : localPlan?.addressType === "Work" ||
                              localPlan?.addressType === "corporate"
                            ? localPlan?.companyName
                            : localPlan?.addressType || "Delivery Location"}
                  </p>

                  {/* 2. Full Address */}
                  <p
                    className="text-truncate plan-full-address"
                    style={{
                      maxWidth: "280px",
                      color: "black",
                    }}
                    title={localPlan?.delivarylocation}
                  >
                    {localPlan?.delivarylocation || ""}
                  </p>

                  {/* 3. User Name & Mobile */}
                  <div className="plan-user-mobile" data-text-role="Caption">
                    <div className="user-detailss mt-1">
                      {localPlan?.username} | {localPlan?.mobileNumber}
                    </div>
                  </div>

                  {/* 4. Student Details (Only shows if School or student data exists) */}
                  {(localPlan?.addressType === "School" ||
                    localPlan?.studentName) && (
                    <div className="caption-section" data-text-role="Caption">
                      <div className="user-detailss mt-1">
                        {localPlan?.studentName}
                        {localPlan?.studentClass
                          ? ` | Class - ${localPlan.studentClass}`
                          : ""}
                        {localPlan?.studentSection
                          ? ` | Section - ${localPlan.studentSection}`
                          : ""}
                      </div>
                    </div>
                  )}
                </div>

                {/* Change Button */}
                <div className="change-button">
                  <div className="change-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      aria-hidden="true"
                    >
                      <path
                        d="M12.7869 4.06006C13.0026 4.06408 13.197 4.13649 13.3679 4.27393L13.4402 4.3374L13.4421 4.33936L14.0691 4.96729H14.0701C14.2584 5.15512 14.3562 5.37816 14.3562 5.63135C14.3561 5.88443 14.2583 6.10722 14.0701 6.29541L8.06909 12.2964L8.12964 12.356L7.97827 12.3872L7.92847 12.437L7.89526 12.4038L6.14429 12.7642L6.14331 12.7632C5.99732 12.7977 5.86495 12.7583 5.75757 12.6509C5.6507 12.5438 5.61079 12.4117 5.64526 12.2661L6.00366 10.5142L5.97144 10.4819L6.02124 10.4312L6.05249 10.2798L6.11304 10.3394L12.1277 4.33936C12.3159 4.15164 12.537 4.05551 12.7869 4.06006ZM3.90894 4.93896C4.82094 5.04553 5.51534 5.25975 5.98022 5.59033L6.14624 5.72217C6.50712 6.04333 6.68917 6.46017 6.68921 6.96631C6.68921 7.46798 6.48149 7.87559 6.07202 8.18018C5.66644 8.48179 5.09567 8.65629 4.37183 8.71533L4.3728 8.71631C3.56599 8.78862 2.97488 8.95356 2.58765 9.20166C2.20735 9.44537 2.02278 9.7739 2.02319 10.1958L2.03003 10.3452C2.06267 10.6821 2.20957 10.9385 2.46753 11.1235C2.76926 11.3398 3.255 11.4829 3.93921 11.5415L4.03296 11.5493L4.03101 11.6431L4.01538 12.3101L4.01245 12.4146L3.90894 12.4077C3.02682 12.3515 2.34286 12.14 1.86987 11.7622C1.39341 11.3812 1.15698 10.8553 1.15698 10.1958C1.15698 9.53364 1.4429 8.99511 2.00562 8.5874C2.56435 8.18297 3.33478 7.93994 4.3064 7.8501C4.8365 7.80039 5.22055 7.69624 5.46948 7.54639C5.71114 7.40131 5.823 7.21012 5.823 6.96631C5.82295 6.63775 5.67929 6.38651 5.37964 6.20361C5.07099 6.01541 4.55566 5.87468 3.82104 5.7915L3.72241 5.78076L3.73218 5.68213L3.79761 5.02881L3.80835 4.92725L3.90894 4.93896ZM12.7771 4.99463C12.7176 4.99466 12.671 5.01448 12.6306 5.05518H12.6296L7.20581 10.4771L7.9314 11.2026L13.3542 5.78076C13.3953 5.73967 13.4148 5.69221 13.4148 5.6333C13.4148 5.58902 13.4041 5.55139 13.3816 5.51807L13.3552 5.48584L12.9236 5.05518C12.883 5.01429 12.8361 4.99463 12.7771 4.99463Z"
                        fill="#6B6B6B"
                        stroke="#6B6B6B"
                        strokeWidth="0.2"
                      />
                    </svg>
                  </div>
                  <div className="change-badge" data-text-role="Badge/Chip">
                    <div className="change-text">
                      <span
                        onClick={() => {
                          handleAddressChange();
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            handleAddressChange();
                          }
                        }}
                        tabIndex={0}
                        role="button"
                        aria-label="Change delivery address"
                        style={{ cursor: "pointer" }}
                      >
                        Change
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <img className="separator-line" src={myplanseparator} alt="" />

              <div className="delivery-details-row">
                {/* Icon */}
                <div className="delivery-icon-wrapper">
                  <img
                    style={{
                      scale: "1.5",
                    }}
                    src="/Assets/securityIcon.svg"
                    alt="Handover"
                    className="delivery-icon"
                  />
                </div>

                {/* Content */}
                <div className="plan-delivery-content-wrapper">
                  <input
                    type="text"
                    className="delivery-notes-input"
                    placeholder="Add Delivery Notes"
                    tabIndex={0}
                    aria-label="Delivery notes"
                    // Mapped to your existing state logic from the old code
                    value={deliveryNotes}
                    onChange={(e) => setDeliveryNotes(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="plan-total-container">
          <div className="plan-total-section">
                      <div className="total-label-container">
                        <div className="total-label">Wallet</div>
                      </div>
                      <div className="total-price-section">
                        <input type="checkbox" checked={useWallet} onChange={e => setUseWallet(e.target.checked)} disabled={walletBalance <= 0} />
                        <span className="wallet-amount">₹{walletDeduction.toFixed(0)} / ₹{walletBalance.toFixed(0)}</span>
                      </div>
                    </div>


        </div> */}

        <div
          style={{
            fontWeight: 500,
            color: "#212121",
            paddingBottom: 8,
            paddingLeft: 8,
            fontSize: 20,
            letterSpacing: "-1px",
          }}
        >
          Apply & Save
        </div>

        {localPlan.status === "Pending Payment" && (
          <div className="promo-wallet-container">
            <div className="wallet-section">
              <input
                type="checkbox"
                className="form-check-input wallet-checkbox"
                tabIndex={0}
                aria-label="Apply wallet credit"
                // id="customCheckbox1"
                name="Apply Wallet"
                onChange={(e) => setUseWallet(e.target.checked)}
                disabled={walletBalance <= 0}
                // style={{
                //   border: discountWallet
                //     ? "1px solid #6B8E23 !important"
                //     : "1px solid #6B6B6B !important",
                //   backgroundColor: discountWallet ? "#6B8E23" : "white",
                // }}
              />
              {/* Wallet Credit Text */}
              <div className="wallet-text">
                <div className="wallet-header">
                  <span className="wallet-title">Apply Wallet Credit</span>
                  <span className="wallet-amount">
                    ₹{walletBalance.toFixed(0)} available
                  </span>
                </div>
                {/* {user.status === "Employee" ? ( */}
                <p className="wallet-subtext">Now you can pay with wallet</p>
                {/* ) : ( */}
                {/* {/* <p className="wallet-subtext">
                    Add ₹
                    {Math.max(
                      0,
                      Math.min(
                        walletSeting?.minCartValueForWallet || 0,
                        (walletSeting?.minCartValueForWallet || 0) -
                          // Number(calculateTaxPrice) +
                          (Number(localPlan.slotTotalAmount) ||
                            // + Number(Cutlery)
                            0)
                      )
                    )}
                    more to use
                  </p>
                )} */}
              </div>
            </div>
          </div>
        )}

        <div className="billing-details-container">
          <span
            style={{
              fontWeight: 500,
              color: "#212121",
              paddingBottom: 8,
              paddingLeft: 8,
              fontSize: 20,
              letterSpacing: "-1px",
            }}
          >
            Billing Details
          </span>
          <div className="billing-details-list">
            {/* <div className="billing-details-row">
              <span>Total Order value</span>
              <span> ₹{localPlan?.slotTotalAmount}</span>
            </div> */}
            <div className="billing-details-row">
              <span>Item Total (Excl. Tax)</span>
              <span> ₹{localPlan?.amountBeforeTax?.toFixed(2)}</span>
            </div>

            {/* 2. Show Tax Amount */}
            <div className="billing-details-row">
              <span>Tax ({localPlan?.taxPercentage || 5}%)</span>
              <span> ₹{localPlan?.taxAmount?.toFixed(2)}</span>
            </div>

            {/* 3. Show Total Order Value (Inclusive) */}
            <div
              className="billing-details-row"
              style={{ borderTop: "1px dashed #ddd", paddingTop: "5px" }}
            >
              <span style={{ fontWeight: 600 }}>Total Order Value</span>
              <span style={{ fontWeight: 600 }}>
                {" "}
                ₹{localPlan?.slotTotalAmount}
              </span>
            </div>
            {localPlan?.slotHubTotalAmount < localPlan?.slotTotalAmount && (
              <div className="billing-details-row">
                <span>Pre-Order Savings</span>
                <span>
                  - ₹
                  {localPlan?.slotHubTotalAmount - localPlan?.slotTotalAmount}
                </span>
              </div>
            )}

            {/* Show preorder discount if present and > 0 */}
            {localPlan?.preorderDiscount > 0 && (
              <div className="billing-details-row">
                <span>Preorder Discount</span>
                <span style={{ color: "#388e3c", fontWeight: 600 }}>
                  - ₹{localPlan.preorderDiscount}
                </span>
              </div>
            )}
            <div className="billing-details-row">
              <span>Wallet</span>
              <span>
                {" "}
                -₹
                {localPlan.status === "Confirmed"
                  ? localPlan.discountWallet
                  : walletDeduction.toFixed(0)}
              </span>
            </div>
            {localPlan.status === "Confirmed" ? (
              <div className="billing-details-row">
                <span>Amount Paid</span>
                <span> ₹{localPlan?.payableAmount}</span>
              </div>
            ) : (
              <div className="billing-details-row">
                <span>Payable Amount</span>
                <span> ₹{payableAmount}</span>
              </div>
            )}
          </div>
        </div>

        <div className="modal-footer-actions">
          {isUnpaidEditable && (
            <>
              <button
                className="skip-btn"
                tabIndex={0}
                aria-label="Skip this order"
                onClick={handleSkipOrCancel}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    if (!loading) handleSkipOrCancel();
                  }
                }}
                disabled={loading}
              >
                Skip Order
                <img
                  src={myplanskip}
                  alt=""
                  style={{ marginLeft: 6, width: 16 }}
                  aria-hidden="true"
                />
              </button>
              <button
                className={`pay-btn ${isProcessing ? "processing" : ""}`}
                tabIndex={0}
                aria-label={`Confirm and pay ${payableAmount} rupees`}
                onClick={async () => {
                  setIsProcessing(true);
                  setLoading(true);
                  try {
                    await handlePayPlan(
                      localPlan,
                      deliveryNotes,
                      walletDeduction,
                    );
                  } catch (e) {
                    setLoading(false);
                    setIsProcessing(false);
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    if (!loading && !isProcessing) {
                      setIsProcessing(true);
                      setLoading(true);
                      handlePayPlan(
                        localPlan,
                        deliveryNotes,
                        walletDeduction,
                      ).catch((e) => {
                        setLoading(false);
                        setIsProcessing(false);
                      });
                    }
                  }
                }}
                disabled={loading || isProcessing}
              >
                <div className="pay-btn-left">
                  <div className="confirm-text">
                    {loading || isProcessing ? (
                      <>
                        <span className="button-loader"></span>
                        Processing
                      </>
                    ) : (
                      "Confirm"
                    )}
                  </div>
                  <div className="and-pay-text">
                    {loading || isProcessing ? "" : "& Pay"}
                  </div>
                </div>
                <div className="pay-btn-right">
                  {localPlan.slotHubTotalAmount > payableAmount ? (
                    <div className="price-container">
                      <span className="original-price">
                        ₹{localPlan.slotHubTotalAmount?.toFixed(0)}
                      </span>
                      <div className="final-price-box">₹{payableAmount}</div>
                    </div>
                  ) : (
                    <div className="price-container" style={{ color: "black" }}>
                      <div className="final-price-box1">₹{payableAmount}</div>
                    </div>
                  )}
                </div>
              </button>
            </>
          )}

          {isPaidEditable && (
            <button
              className="skip-btn"
              onClick={handleSkipOrCancel}
              disabled={loading}
            >
              Cancel Order
              <img
                src={myplancancelicon}
                alt=""
                style={{ marginLeft: 6, width: 16 }}
              />
            </button>
          )}
          {isConfirmed && (
            <button
              className="track-order-btn"
              tabIndex={0}
              aria-label="Track your order"
              onClick={() => handleTrackOrder(plan)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  handleTrackOrder(plan);
                }
              }}
            >
              <span> Track Order</span>

              <img
                style={{
                  scale: "0.8",
                }}
                src="/Assets/tracker.svg"
                alt=""
                aria-hidden="true"
              />
            </button>
          )}
        </div>
      </div>

      {/* Location Modal */}
      <LocationModal2
        show={showLocationModal}
        onClose={() => setShowLocationModal(false)}
        onAddressSelected={handleAddressSelected}
        selectedLocationId={localPlan?.addressId}
      />

      {/* Add More Items Modal */}
      <AddMoreToSlotModal
        show={showAddMoreModal}
        onClose={() => setShowAddMoreModal(false)}
        planId={localPlan._id}
        userId={userId}
        onItemsUpdated={(updatedPlan) => {
          if (!updatedPlan) {
            // Plan was deleted (empty)
            Swal2.fire({
              toast: true,
              position: "bottom",
              showConfirmButton: false,
              timer: 2500,
              timerProgressBar: true,
              html: `
          <div class="myplans-toast-content">
            <img src="${checkCircle}" alt="Success" class="myplans-toast-check" />
            <div class="myplans-toast-text">
              <div class="myplans-toast-title">Plan Removed.</div>
              <div class="myplans-toast-subtitle">Plan removed as it is empty</div>
            </div>
          </div>
        `,
              customClass: {
                popup: "myplans-custom-toast",
                htmlContainer: "myplans-toast-html",
              },
              didOpen: () => {
                // Position above bottom nav
                const toast = document.querySelector(".myplans-custom-toast");
                if (toast) {
                  toast.style.bottom = "90px"; // Position above bottom nav
                  toast.style.left = "50%";
                  toast.style.transform = "translateX(-50%)";
                  toast.style.position = "fixed";
                }
              },
            });
            setShowAddMoreModal(false);
            onClose(); // Close the parent ViewPlanModal immediately
            if (onPlanUpdated) onPlanUpdated(); // Refresh the main list
            return;
          }
          // Update localPlan immediately with fresh data from backend
          if (updatedPlan) {
            setLocalPlan(updatedPlan);
          }
          setShowAddMoreModal(false);
          if (onPlanUpdated) onPlanUpdated();
        }}
      />
    </div>
  );
};

const MyPlan = () => {
  const navigate = useNavigate();
  const [loadingTrackId, setLoadingTrackId] = useState(null);
  const [selectedTab, setSelectedTab] = useState(null);
  const [plans, setPlans] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [trackModalVisible, setTrackModalVisible] = useState(false);
  const [currentTrackedOrder, setCurrentTrackedOrder] = useState(null);
  const [showQuickAnswers, setShowQuickAnswers] = useState(false);
  const [processingPlanId, setProcessingPlanId] = useState(null);
  const [isLoadingPlans, setIsLoadingPlans] = useState(true);
  const [isProcessingAllPlans, setIsProcessingAllPlans] = useState(false);
  const { wallet, fetchWalletData } = useContext(WalletContext);
  const walletBalance = wallet?.balance || 0;
  const [sessionDetails, setSessionDetails] = useState(null);
  // TODO: wire this to your auth/user context
  // parse stored user once so we can access properties safely
  let user = null;
  try {
    user = JSON.parse(localStorage.getItem("user") || "null");
  } catch (e) {
    user = null;
  }
  const address = JSON.parse(
    localStorage.getItem("primaryAddress") ??
      localStorage.getItem("currentLocation"),
  );

  // console.log(address);
  const userId = user ? user._id : null;
  // console.log('UW3MR',JSON.stringify(userId))

  const fetchPlans = async () => {
    if (!userId) {
      setIsLoadingPlans(false);
      return;
    }
    try {
      setIsLoadingPlans(true);
      const res = await axios.get(
        `https://dailydish.in/api/user/plan/get-plan/${userId}`,
      );
      if (res.data.success) {
        const newPlans = res.data.data || [];
        setPlans(newPlans);

        // console.log("plans are", newPlans);

        if (selectedPlan && isModalOpen) {
          const updatedSelectedPlan = newPlans.find(
            (p) => p._id === selectedPlan._id,
          );
          if (updatedSelectedPlan) {
            setSelectedPlan(updatedSelectedPlan);
          } else {
            setIsModalOpen(false);
            setSelectedPlan(null);
          }
        }
      }
    } catch (err) {
      console.error("fetch plans error", err);
    } finally {
      setIsLoadingPlans(false);
    }
  };

  useEffect(() => {
    fetchPlans();
  }, [userId]);

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // categorize plans
  const categorizedOrders = useMemo(() => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    const dayAfterTomorrow = new Date(today);
    dayAfterTomorrow.setDate(dayAfterTomorrow.getDate() + 2);

    const todayOrders = [];
    const tomorrowOrders = [];
    const upcomingOrders = [];

    plans.forEach((plan) => {
      const d = new Date(plan.deliveryDate);
      d.setHours(0, 0, 0, 0);
      if (d.getTime() === today.getTime()) todayOrders.push(plan);
      else if (d.getTime() === tomorrow.getTime()) tomorrowOrders.push(plan);
      else if (d >= dayAfterTomorrow) upcomingOrders.push(plan);
    });

    return { todayOrders, tomorrowOrders, upcomingOrders };
  }, [plans]);
  useEffect(() => {
    const { todayOrders, tomorrowOrders, upcomingOrders } = categorizedOrders;

    const hasToday = todayOrders.length > 0;
    const hasTomorrow = tomorrowOrders.length > 0;
    const hasUpcoming = upcomingOrders.length > 0;

    // 1. If we are currently on a valid tab that has data, don't change anything.
    if (selectedTab === "today" && hasToday) return;
    if (selectedTab === "tomorrow" && hasTomorrow) return;
    if (selectedTab === "upcoming" && hasUpcoming) return;

    // 2. Otherwise, find the closest available tab
    if (hasToday) {
      setSelectedTab("today");
    } else if (hasTomorrow) {
      setSelectedTab("tomorrow");
    } else if (hasUpcoming) {
      setSelectedTab("upcoming");
    } else {
      // If absolutely no plans exist anywhere, default to today
      setSelectedTab("today");
    }
  }, [categorizedOrders, selectedTab]);
  const getCurrentTabOrders = () => {
    switch (selectedTab) {
      case "today":
        return categorizedOrders.todayOrders;
      case "tomorrow":
        return categorizedOrders.tomorrowOrders;
      case "upcoming":
        return categorizedOrders.upcomingOrders;
      default:
        return [];
    }
  };

  // NO moment version
  const getTimeRemaining = (plan) => {
    const now = new Date();

    // Assume plan.deliveryDate is an ISO string or Date
    const deliveryDate = new Date(plan.deliveryDate);

    // Normalize to start of the day in local time
    deliveryDate.setHours(0, 0, 0, 0);

    // Only use cutoff time for all plans (preorder only)
    let targetTime = new Date(deliveryDate.getTime());
    if (plan.session === "Lunch") targetTime.setHours(10, 0, 0, 0);
    else targetTime.setHours(16, 0, 0, 0);

    const diffMs = targetTime.getTime() - now.getTime();
    if (diffMs <= 0) {
      return { days: 0, hours: 0, mins: 0, isExpired: true };
    }
    const totalMinutes = Math.floor(diffMs / (1000 * 60));
    const days = Math.floor(totalMinutes / (60 * 24));
    const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
    const mins = totalMinutes % 60;
    return {
      days,
      hours,
      mins,
      isExpired: false,
    };
  };

  const handleViewPlan = (plan) => {
    setSelectedPlan(plan);
    setIsModalOpen(true);
  };
  async function handleTrackOrder(plan) {
    if (!plan.orderId) return;
    setLoadingTrackId(plan._id);
    closeModal();
    try {
      const res = await axios.get(
        `https://dailydish.in/api/admin/getOrderByOrderId/${plan.orderId}`,
      );
      if (res.data.success) {
        const order = res.data.data;

        // map API order to the shape your modal logic expects
        const items = (order.allProduct || []).map((p) => ({
          name: p.name,
          quantity: p.quantity,
        }));
        const total = order.subTotal || 0;
        const rawStatus = order.status || order.orderstatus || "Cooking";
        const orderid = order.orderid || order._id;
        const deliveryDate = new Date(order.deliveryDate);
        const session = order.session;
        setSessionDetails(session);

        // simple ETA string; you can refine as needed
        const eta =
          deliveryDate.toLocaleString("en-IN", {
            day: "2-digit",
            month: "short",
            hour: "2-digit",
            minute: "2-digit",
          }) + ` (${session})`;

        setCurrentTrackedOrder({ items, total, rawStatus, orderid, eta });
        setTrackModalVisible(true);
      } else {
        alert(res.data.message || "Failed to fetch order details");
      }
    } catch (err) {
      console.error("track order error", err);
      alert("Failed to fetch order details");
    } finally {
      setLoadingTrackId(null);
    }
  }
  const closeModal = () => {
    setSelectedPlan(null);
    setIsModalOpen(false);
  };

  const onPlanUpdated = () => {
    fetchPlans();
  };

  const getTabDateDisplay = (tabName) => {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    const dayAfterTomorrow = new Date(today);
    dayAfterTomorrow.setDate(dayAfterTomorrow.getDate() + 2);

    switch (tabName) {
      case "today":
        return {
          date: formatDate(today.toISOString()),
          day: formatDay(today.toISOString()),
        };
      case "tomorrow":
        return {
          date: formatDate(tomorrow.toISOString()),
          day: formatDay(tomorrow.toISOString()),
        };
      case "upcoming":
        return {
          date: formatDate(dayAfterTomorrow.toISOString()),
          day: formatDay(dayAfterTomorrow.toISOString()),
        };
      default:
        return { date: "", day: "" };
    }
  };

  const currentTabOrders = getCurrentTabOrders();
  const mobile = user?.Mobile;
  const username = user?.Fname;

  async function handlePayPlan(plan, deliveryNotes, discountWallet = 0) {
    try {
      const amount = plan.payableAmount - discountWallet;

      // If amount is 0, directly create order
      if (amount === 0) {
        const generateUniqueId = () => {
          const timestamp = Date.now().toString().slice(-4);
          const randomNumber = Math.floor(1000 + Math.random() * 9000);
          return `${address?.prefixcode}${timestamp}${randomNumber}`;
        };

        const configObj = {
          method: "post",
          baseURL: "https://dailydish.in/api/",
          url: "/user/plan/create-from-plan",
          headers: { "content-type": "application/json" },
          data: {
            userId,
            planId: plan._id,
            discountWallet,
            coupon: 0,
            studentName: plan.studentName,
            studentClass: plan.studentClass,
            studentSection: plan.studentSection,
            addressType: plan.addressType,
            coordinates: plan.coordinates,
            hubName: plan?.hubName,
            username: username,
            mobile: mobile,
            deliveryNotes: deliveryNotes,
            orderid: generateUniqueId(),
          },
        };

        const res = await axios(configObj);
        if (res.status === 200 || res.data?.success) {
          // Check if this is a duplicate order
          if (res.data?.duplicate) {
            console.log("Order already exists, skipping wallet deduction");
          }

          await fetchWalletData();

          // Pass all payment details in URL parameters for wallet payment
          const paymentParams = new URLSearchParams({
            transactionId: "completed",
            userId: userId,
            session: plan.session,
            deliveryDate: plan.deliveryDate,
            username: username || plan.username,
            amount: amount,
            orderId: plan._id,
            hubName: plan.hubName || "",
            delivarylocation: plan.delivarylocation || "",
            status: "COMPLETED",
            paymentMethod: "wallet",
          });

          navigate("/payment-success?" + paymentParams.toString());

          setTimeout(() => {
            if (typeof fetchPlans === "function") {
              fetchPlans();
            }
            setProcessingPlanId(null);
          }, 1200);
        }
        return;
      }

      // For paid orders, use Razorpay
      // IMPORTANT: Order is created BEFORE payment, but plan status remains "Pending Payment"
      // After successful payment, the webhook will update plan status to "Confirmed"
      const generateUniqueId = () => {
        const timestamp = Date.now().toString().slice(-4);
        const randomNumber = Math.floor(1000 + Math.random() * 9000);
        return `${address?.prefixcode}${timestamp}${randomNumber}`;
      };

      const configObj = {
        method: "post",
        baseURL: "https://dailydish.in/api/",
        url: "/user/plan/create-from-plan",
        headers: { "content-type": "application/json" },
        data: {
          userId,
          planId: plan._id,
          discountWallet,
          coupon: 0,
          studentName: plan.studentName,
          studentClass: plan.studentClass,
          studentSection: plan.studentSection,
          addressType: plan.addressType,
          coordinates: plan.coordinates,
          hubName: plan?.hubName,
          username: username,
          mobile: mobile,
          deliveryNotes: deliveryNotes,
          orderid: generateUniqueId(),
        },
      };

      // Prepare Razorpay order data
      const razorpayOrderData = {
        userId,
        username,
        Mobile: mobile,
        amount,
        orderId: plan._id,
        config: JSON.stringify(configObj),
        cartId: null,
        offerconfig: null,
        cart_id: null,
      };

      // Use Razorpay payment
      const { handleRazorpayPayment } = await import("../Helper/razorpay");

      await handleRazorpayPayment(
        razorpayOrderData,
        async (response) => {
          // This will NOT be called when using callback_url
          // Razorpay will redirect to backend callback URL instead
          // Backend will then redirect to /payment-success with all details
          console.log(
            "Payment handler called (should not happen with callback_url):",
            response,
          );
        },
        (error) => {
          // Payment failed or cancelled
          console.error("Payment failed:", error);
          setProcessingPlanId(null);

          // Redirect to payment success page with failure parameters
          const failureParams = new URLSearchParams({
            transactionId: "",
            userId: userId,
            status: "FAILED",
            paymentMethod: "razorpay",
            error: error.message || "Payment could not be processed",
          });
          navigate("/payment-success?" + failureParams.toString());
        },
      );
    } catch (err) {
      setProcessingPlanId(null);
      console.error("pay plan error", err);
      if (err.response?.data?.error === "OUT_OF_STOCK") {
        Swal2.fire({
          icon: "info",
          title: "Item Unavailable",
          text: err.response.data.message,
          // text: 'Oops, That item just ran out. Please pick something else to continue.',
          confirmButtonText: "See Other Options",
          confirmButtonColor: "#d33",
        }).then(() => {
          if (isModalOpen) closeModal();
          // fetchPlans(); // Refresh after closing modal
          navigate("/");
        });
      } else {
        toast.error(err.response?.data?.message || "Failed to start payment");
      }
    }
  }

  // async function handlePayPlan(plan, deliveryNotes, discountWallet = 0) {
  //   try {
  //     const amount = plan.payableAmount - discountWallet;
  //     const generateUniqueId = () => {
  //       const timestamp = Date.now().toString().slice(-4);
  //       const randomNumber = Math.floor(1000 + Math.random() * 9000);
  //       return `${address?.prefixcode}${timestamp}${randomNumber}`;
  //     };
  //     const configObj = {
  //       method: "post",
  //       baseURL: "https://dailydish.in/api/",
  //       url: "/user/plan/create-from-plan",
  //       headers: { "content-type": "application/json" },
  //       data: {
  //         userId,
  //         planId: plan._id,
  //         // optional discounts:
  //         discountWallet,
  //         coupon: 0,
  //         // couponId: null,
  //         // companyId: null,
  //         // companyName: "Normal User",
  //         // customerType: "Individual",
  //         studentName: plan.studentName,
  //         studentClass: plan.studentClass,
  //         studentSection: plan.studentSection,
  //         addressType: plan.addressType,
  //         coordinates: plan.coordinates,
  //         hubName: plan?.hubName,
  //         username: username,
  //         mobile: mobile,
  //         deliveryNotes: deliveryNotes,
  //         orderid: generateUniqueId(),
  //       },
  //     };

  //     // console.log(configObj, "configgggggggg");
  //     const config1 = {
  //       url: "/user/addpaymentphonepay",
  //       method: "post",
  //       baseURL: "https://dailydish.in/api/",
  //       headers: { "content-type": "application/json" },
  //       data: {
  //         userId,
  //         username,
  //         Mobile: mobile,
  //         amount,
  //         transactionid: null,
  //         orderid: generateUniqueId(),
  //         config: JSON.stringify(configObj),
  //         cartId: null,
  //         offerconfig: null,
  //         cart_id: null,
  //       },
  //     };

  //     const res = await axios(amount > 0 ? config1 : configObj);
  //     if (res.status === 200 || res.data?.success) {
  //       await fetchWalletData();
  //       const redirectInfo = res.data?.url;

  //       if (amount === 0) {
  //         navigate("/payment-success?transactionId=completed");
  //         // Swal2.fire({
  //         //   toast: true,
  //         //   position: "bottom",
  //         //   showConfirmButton: false,
  //         //   timer: 2500,
  //         //   timerProgressBar: true,
  //         //   html: `
  //         //         <div class="myplans-toast-content">
  //         //           <img src="${checkCircle}" alt="Success" class="myplans-toast-check" />
  //         //           <div class="myplans-toast-text">
  //         //             <div class="myplans-toast-title">Success!</div>
  //         //             <div class="myplans-toast-subtitle">Plan Confirmed successfully! 🎉</div>
  //         //           </div>
  //         //         </div>
  //         //       `,
  //         //   customClass: {
  //         //     popup: "myplans-custom-toast",
  //         //     htmlContainer: "myplans-toast-html",
  //         //   },
  //         //   didOpen: () => {
  //         //     // Position above bottom nav
  //         //     const toast = document.querySelector(".myplans-custom-toast");
  //         //     if (toast) {
  //         //       toast.style.bottom = "90px"; // Position above bottom nav
  //         //       toast.style.left = "50%";
  //         //       toast.style.transform = "translateX(-50%)";
  //         //       toast.style.position = "fixed";
  //         //     }
  //         //   },
  //         // });
  //       }
  //       // else {
  //       //    toast.success("Order created! Redirecting...", {
  //       //      position: "bottom-center",
  //       //      autoClose: 2000
  //       //    });
  //       // }

  //       setTimeout(() => {
  //         if (typeof fetchPlans === "function") {
  //           fetchPlans();
  //         }

  //         // Reset processing state
  //         setProcessingPlanId(null);

  //         if (amount > 0) {
  //           if (redirectInfo?.url) {
  //             window.location.href = redirectInfo.url;
  //           } else if (redirectInfo?.redirectUrl) {
  //             window.location.href = redirectInfo.redirectUrl;
  //           }
  //         }
  //         // If amount === 0, the code stops here. The user stays on the page with the success toast.
  //       }, 1200);
  //     }
  //   } catch (err) {
  //     // setLoading(false);
  //     // Reset processing state on error
  //     setProcessingPlanId(null);
  //     console.error("pay plan error", err);
  //     if (err.response?.data?.error === "OUT_OF_STOCK") {
  //       Swal2.fire({
  //         icon: "info",
  //         title: "Item Unavailable",
  //         text: err.response.data.message,
  //         // text: 'Oops, That item just ran out. Please pick something else to continue.',
  //         confirmButtonText: "See Other Options",
  //         confirmButtonColor: "#d33",
  //       }).then(() => {
  //         if (isModalOpen) closeModal();
  //         // fetchPlans(); // Refresh after closing modal
  //         navigate("/");
  //       });
  //     } else {
  //       toast.error(err.response?.data?.message || "Failed to start payment");
  //     }
  //   }
  // }

  // async function handlePayPlan(plan, deliveryNotes, discountWallet = 0) {
  //   console.log("Initiating payment for plan:", plan);
  //   console.log("plan id", plan?._id);
  //   try {
  //     const amount = plan?.payableAmount;

  //     console.log("amt initiated", amount);

  //     // 🔑 Generate orderId ONCE

  //     const generateUniqueId = () => {
  //       const timestamp = Date.now().toString().slice(-4);
  //       const randomNumber = Math.floor(1000 + Math.random() * 9000);
  //       return `${address?.prefixcode}${timestamp}${randomNumber}`;
  //     };

  //     const orderid = generateUniqueId();

  //     /* =========================
  //      1️⃣ CREATE PLAN ORDER
  //      ========================= */
  //     const createPlanConfig = {
  //       method: "post",
  //       baseURL: "https://dailydish.in/api/",
  //       url: "/user/plan/create-from-plan",
  //       headers: { "Content-Type": "application/json" },
  //       data: {
  //         userId,
  //         planId: plan?._id,
  //         discountWallet,
  //         coupon: 0,

  //         studentName: plan.studentName,
  //         studentClass: plan.studentClass,
  //         studentSection: plan.studentSection,

  //         addressType: plan.addressType,
  //         coordinates: plan.coordinates,
  //         hubName: plan?.hubName,

  //         username,
  //         mobile,
  //         deliveryNotes,
  //         orderid,
  //       },
  //     };

  //     console.log("createplanconfig", createPlanConfig);

  //     const createRes = await axios(createPlanConfig);

  //     console.log("createRes", createRes);

  //     if (!createRes.data?.success) {
  //       throw new Error("Order creation failed");
  //     }

  //     /* =========================
  //      2️⃣ INITIATE PHONEPE
  //      ========================= */
  //     const phonepeConfig = {
  //       method: "post",
  //       baseURL: "https://dailydish.in/api/",
  //       url: "/user/addpaymentphonepay",
  //       headers: { "Content-Type": "application/json" },
  //       data: {
  //         userId,
  //         username,
  //         Mobile: mobile,
  //         amount,
  //         transactionid: null,
  //         orderid,
  //         config: JSON.stringify(createPlanConfig),
  //         cartId: null,
  //         offerconfig: null,
  //       },
  //     };

  //     console.log("phonepeConfig", phonepeConfig);

  //     const paymentRes = await axios(phonepeConfig);

  //     const redirectInfo = paymentRes.data;

  //     /* =========================
  //      3️⃣ UI FEEDBACK
  //      ========================= */
  //     await fetchWalletData();

  //     Swal2.fire({
  //       toast: true,
  //       position: "bottom",
  //       icon: "success",
  //       title: "Order Placed",
  //       text: "Redirecting to PhonePe...",
  //       showConfirmButton: false,
  //       timer: 2000,
  //       timerProgressBar: true,
  //       customClass: {
  //         popup: "me-small-toast",
  //         title: "me-small-toast-title",
  //       },
  //     });

  //     /* =========================
  //      4️⃣ REDIRECT TO PHONEPE
  //      ========================= */
  //     setTimeout(() => {
  //       if (redirectInfo?.url) {
  //         window.location.href = redirectInfo.url;
  //       } else if (redirectInfo?.redirectUrl) {
  //         window.location.href = redirectInfo.redirectUrl;
  //       } else {
  //         toast.error("Payment gateway not available");
  //       }
  //     }, 1500);
  //   } catch (err) {
  //     console.error("PhonePe payment error:", err);

  //     if (err.response?.data?.error === "OUT_OF_STOCK") {
  //       Swal2.fire({
  //         icon: "info",
  //         title: "Item Unavailable",
  //         text: err.response.data.message,
  //         confirmButtonText: "See Other Options",
  //         confirmButtonColor: "#d33",
  //       }).then(() => navigate("/home"));
  //     } else {
  //       toast.error(err.response?.data?.message || "Payment failed");
  //     }
  //   }
  // }
  async function proceedWithPayment(walletDeduction = 0) {
    try {
      setIsProcessingAllPlans(true);

      // Get ALL pending payment plans from entire list (not just current tab)
      const allPendingPlans = plans.filter(
        (p) => p.status === "Pending Payment",
      );

      if (allPendingPlans.length === 0) {
        toast.error("No pending plans to confirm");
        setIsProcessingAllPlans(false);
        return;
      }

      // Calculate total amount
      const totalAmount = allPendingPlans.reduce(
        (sum, plan) => sum + (plan.payableAmount || plan.slotTotalAmount || 0),
        0,
      );

      // Apply wallet deduction
      const finalPayableAmount = Math.max(0, totalAmount - walletDeduction);

      // If amount is 0, directly confirm without payment gateway
      if (finalPayableAmount === 0) {
        const res = await axios.post(
          "https://dailydish.in/api/user/plan/confirm-all",
          {
            userId,
            planIds: allPendingPlans.map((p) => p._id),
            discountWallet: walletDeduction,
          },
        );

        if (res.data.success) {
          Swal2.fire({
            toast: true,
            position: "bottom",
            showConfirmButton: false,
            timer: 2500,
            timerProgressBar: true,
            html: `
              <div class="myplans-toast-content">
                <img src="${checkCircle}" alt="Success" class="myplans-toast-check" />
                <div class="myplans-toast-text">
                  <div class="myplans-toast-title">Success!</div>
                  <div class="myplans-toast-subtitle">All ${allPendingPlans.length} plan(s) confirmed! 🎉</div>
                </div>
              </div>
            `,
          });
          await fetchWalletData();
          await fetchPlans();
        } else {
          toast.error(res.data.message || "Failed to confirm plans");
        }
        setIsProcessingAllPlans(false);
        return;
      }

      // Generate config for payment callback to execute
      const configObj = {
        method: "post",
        baseURL: "https://dailydish.in/api/",
        url: "/user/plan/confirm-all",
        headers: { "content-type": "application/json" },
        data: {
          userId,
          planIds: allPendingPlans.map((p) => p._id),
          discountWallet: walletDeduction,
        },
      };

      // Create Razorpay order for multiple plans
      const orderResponse = await axios.post(
        "https://dailydish.in/api/user/razorpay/create-order-multiple",
        {
          userId,
          username: username,
          Mobile: mobile,
          amount: finalPayableAmount,
          planIds: allPendingPlans.map((p) => p._id),
          discountWallet: walletDeduction,
          config: JSON.stringify(configObj),
        },
      );

      if (!orderResponse.data?.razorpayOrderId) {
        toast.error("Failed to create payment order");
        setIsProcessingAllPlans(false);
        return;
      }

      // Initialize Razorpay payment
      const options = {
        key: orderResponse.data.key,
        amount: orderResponse.data.amount,
        currency: orderResponse.data.currency,
        order_id: orderResponse.data.razorpayOrderId,
        handler: async (paymentResponse) => {
          try {
            // Verify payment signature
            const verifyResponse = await axios.post(
              "https://dailydish.in/api/user/razorpay/verify-payment",
              {
                razorpay_order_id: paymentResponse.razorpay_order_id,
                razorpay_payment_id: paymentResponse.razorpay_payment_id,
                razorpay_signature: paymentResponse.razorpay_signature,
                transactionId: orderResponse.data.id,
              },
            );

            if (verifyResponse.data?.success) {
              Swal2.fire({
                toast: true,
                position: "bottom",
                showConfirmButton: false,
                timer: 2500,
                timerProgressBar: true,
                html: `
                  <div class="myplans-toast-content">
                    <img src="${checkCircle}" alt="Success" class="myplans-toast-check" />
                    <div class="myplans-toast-text">
                      <div class="myplans-toast-title">Success!</div>
                      <div class="myplans-toast-subtitle">All ${allPendingPlans.length} plan(s) confirmed! 🎉</div>
                    </div>
                  </div>
                `,
              });
              await fetchWalletData();
              await fetchPlans();
            } else {
              toast.error("Payment verification failed");
            }
          } catch (error) {
            console.error("Payment verification error:", error);
            toast.error("Payment verification failed");
          } finally {
            setIsProcessingAllPlans(false);
          }
        },
        prefill: {
          name: username,
          contact: mobile,
        },
        theme: {
          color: "#6b8e23",
        },
        modal: {
          ondismiss: () => {
            setIsProcessingAllPlans(false);
            toast.error("Payment cancelled");
          },
        },
      };

      const razorpayWindow = new window.Razorpay(options);
      razorpayWindow.open();
    } catch (err) {
      console.error("Error in payment for all plans:", err);
      toast.error(err.response?.data?.message || "Payment initiation failed");
      setIsProcessingAllPlans(false);
    }
  }

  function handlePayAllPlans() {
    // Get pending plans and calculate totals
    const allPendingPlans = plans.filter((p) => p.status === "Pending Payment");

    if (allPendingPlans.length === 0) {
      toast.error("No pending plans to confirm");
      return;
    }

    const totalAmount = allPendingPlans.reduce(
      (sum, plan) => sum + (plan.payableAmount || plan.slotTotalAmount || 0),
      0,
    );

    // If wallet balance is 0 or total is 0, proceed directly
    if (walletBalance <= 0 || totalAmount === 0) {
      proceedWithPayment(0);
      return;
    }

    const maxWalletDeduction = Math.min(walletBalance, totalAmount);
    const finalAmount = totalAmount - maxWalletDeduction;

    // Show wallet dialog
    Swal2.fire({
      title: "Use Wallet Credit?",
      html: `
        <div style="text-align: left; padding: 10px;">
          <div style="margin: 12px 0; font-size: 14px;">
            <span style="color: #666;">Total Amount:</span>
            <span style="float: right; font-weight: 600;">₹${totalAmount.toFixed(0)}</span>
          </div>
          <div style="margin: 12px 0; font-size: 14px;">
            <span style="color: #666;">Wallet Available:</span>
            <span style="float: right; font-weight: 600; color: #6b8e23;">₹${maxWalletDeduction.toFixed(0)}</span>
          </div>
          <div style="border-top: 1px solid #eee; margin: 12px 0;"></div>
          <div style="margin: 12px 0; font-size: 16px;">
            <span style="color: #333;">You Pay:</span>
            <span style="float: right; font-weight: 700; color: #6b8e23; font-size: 18px;">₹${finalAmount.toFixed(0)}</span>
          </div>
        </div>
      `,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Use Wallet",
      cancelButtonText: "Pay Full Amount",
      confirmButtonColor: "#6b8e23",
      cancelButtonColor: "#999",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        proceedWithPayment(maxWalletDeduction);
      } else if (result.dismiss === Swal2.DismissReason.cancel) {
        proceedWithPayment(0);
      }
    });
  }
  return (
    <div className="my-plan-container mainbg">
      <div className="checkoutcontainer">
        {/* Header */}
        <div className="mobile-banner-updated">
          <div
            className="screen-checkout mb-2 checkout-header d-flex align-items-center"
            style={{ gap: "24px" }}
          >
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="36"
                height="36"
                viewBox="0 0 36 36"
                fill="none"
                onClick={() => navigate("/home")}
                className="cursor-pointer"
              >
                <path
                  d="M11.7375 19.5002L19.0875 26.8502C19.3875 27.1502 19.5315 27.5002 19.5195 27.9002C19.5075 28.3002 19.351 28.6502 19.05 28.9502C18.75 29.2252 18.4 29.3692 18 29.3822C17.6 29.3952 17.25 29.2512 16.95 28.9502L7.05001 19.0502C6.90001 18.9002 6.79351 18.7377 6.73051 18.5627C6.66751 18.3877 6.63701 18.2002 6.63901 18.0002C6.64101 17.8002 6.67251 17.6127 6.73351 17.4377C6.79451 17.2627 6.90051 17.1002 7.05151 16.9502L16.9515 7.05019C17.2265 6.77519 17.5705 6.6377 17.9835 6.6377C18.3965 6.6377 18.7525 6.77519 19.0515 7.05019C19.3515 7.35019 19.5015 7.7067 19.5015 8.1197C19.5015 8.5327 19.3515 8.8887 19.0515 9.1877L11.7375 16.5002H28.5C28.925 16.5002 29.2815 16.6442 29.5695 16.9322C29.8575 17.2202 30.001 17.5762 30 18.0002C29.999 18.4242 29.855 18.7807 29.568 19.0697C29.281 19.3587 28.925 19.5022 28.5 19.5002H11.7375Z"
                  fill="#FAFAFA"
                />
              </svg>
            </div>
            <div
              className=""
              style={{ display: "flex", alignItems: "center", gap: 3 }}
            >
              <h3 className="tagline">My Plans</h3>
              <img
                src={pending}
                alt=""
                onClick={() => setShowQuickAnswers(true)}
                style={{
                  width: "20px",
                  height: "20px",
                  position: "relative",
                  top: "-6px",
                  cursor: "pointer",
                }}
              />
            </div>
          </div>
          <div className="d-flex justify-content-end align-items-center w-100">
            <div
              onClick={() => navigate("/orders")}
              style={{
                cursor: "pointer",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                gap: "2px",
                marginLeft: "auto", // This pushes it to the right
                marginRight: "15px",
              }}
            >
              <img
                src={orderhistoryicon}
                alt="My Orders"
                className="icon-img-l"
              />
              <h6
                style={{
                  color: "#2c2c2c",
                  fontSize: "16px",
                  fontWeight: "400",
                  fontFamily: "Inter",
                  textDecoration: "underline",
                  margin: 0,
                  whiteSpace: "nowrap", // Prevents text wrapping
                }}
              >
                Order History
              </h6>
            </div>
          </div>
        </div>

        {/* Tabs */}
        <div className="myplan-mid-section">
          <div className="tabs-container">
            {["today", "tomorrow", "upcoming"].map((tab) => {
              const isActive = selectedTab === tab;
              const label = tab.charAt(0).toUpperCase() + tab.slice(1);

              // Check if plan exists for this specific tab
              let hasPlan = false;
              if (tab === "today" && categorizedOrders.todayOrders.length > 0)
                hasPlan = true;
              if (
                tab === "tomorrow" &&
                categorizedOrders.tomorrowOrders.length > 0
              )
                hasPlan = true;
              if (
                tab === "upcoming" &&
                categorizedOrders.upcomingOrders.length > 0
              )
                hasPlan = true;

              return (
                <div
                  key={tab}
                  onClick={() => hasPlan && setSelectedTab(tab)}
                  // Add 'grayed-out' class if there is NO plan
                  className={`tab-btn ${isActive ? "active" : ""} ${
                    !hasPlan ? "grayed-out" : ""
                  }`}
                >
                  <h1 className={`tab-label ${isActive ? "active" : ""}`}>
                    {label}
                  </h1>
                </div>
              );
            })}
          </div>

          {/* Cards */}
          <div className="plans-list">
            {isLoadingPlans ? (
              <div className="loading-plans">
                <div className="plans-loader-container">
                  <span className="plans-loader"></span>
                  <div className="loading-text">Loading your plans...</div>
                </div>
              </div>
            ) : currentTabOrders.length === 0 ? (
              <div className="no-plans-text">No plans for this day yet</div>
            ) : (
              currentTabOrders.map((plan) => {
                const { days, hours, mins, isExpired } = getTimeRemaining(plan);
                const now = new Date();
                const deadline = new Date(plan.paymentDeadline);
                const isBeforeDeadline = now < deadline;
                const payableAmount = Math.max(
                  0,
                  plan?.payableAmount - (plan.discountWallet || 0),
                  // -(plan.preorderDiscount || 0)
                ).toFixed(0);
                const isUnpaidEditable =
                  plan.status === "Pending Payment" && isBeforeDeadline;

                const isPaidEditable =
                  plan.status === "Confirmed" && isBeforeDeadline;
                const isPaidLocked =
                  plan.status === "Confirmed" && !isBeforeDeadline;

                const isConfirmed = plan.status === "Confirmed";

                return (
                  <>
                    <div
                      key={plan._id}
                      className={`plan-card ${
                        plan.status === "Confirmed" ? "confirmed" : ""
                      }`}
                    >
                      {/* reminder for unpaid before cutoff */}

                      <div className="plan-header">
                        <div className="plan-session-info">
                          <h3 className="session-title">{plan.session}</h3>
                          <div className="delivery-time-text">
                            {/* static for now; optionally store slot time in DB later */}
                            <span className=" fw-semibold">Delivery : </span>

                            <span className=" fw-medium">
                              {plan.session === "Lunch"
                                ? "12:00 to 01:00PM"
                                : "07:30 to 08:30PM"}
                            </span>
                          </div>
                        </div>
                        {plan.status === "Confirmed" && (
                          <div className="status-badge-confirmed">
                            <img
                              src={success}
                              alt=""
                              style={{ width: "16px", height: "16px" }}
                            />{" "}
                            Confirmed
                          </div>
                        )}
                        {plan.status === "Skipped" && (
                          <div className="status-badge-skipped">Skipped</div>
                        )}
                        {plan.status === "Cancelled" && (
                          <div className="status-badge-cancele">
                            {" "}
                            <img
                              src={myplancancel}
                              alt=""
                              style={{ width: "14px", height: "14px" }}
                            />{" "}
                            Cancelled
                          </div>
                        )}
                        {plan.status === "Pending Payment" && (
                          <div className="status-badge-pending">
                            <img
                              src={pending}
                              alt=""
                              style={{ width: "15px", height: "15px" }}
                            />{" "}
                            Pending
                          </div>
                        )}
                        {selectedTab === "upcoming" && (
                          <div className="upcoming-date-badge">
                            <div className="date-column">
                              <div className="date-day">
                                {new Date(plan.deliveryDate).toLocaleDateString(
                                  "en-US",
                                  {
                                    day: "numeric",
                                  },
                                )}
                              </div>
                              <div className="date-month">
                                {new Date(plan.deliveryDate).toLocaleDateString(
                                  "en-US",
                                  {
                                    month: "short",
                                  },
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>

                      <div className="location-row">
                        <img
                          src={myplanlocation}
                          alt=""
                          style={{ width: 24, height: 24, marginBottom: "3px" }}
                        />
                        <div className="plan-location-text">
                          <h1 className="addressLine1">
                            {plan?.addressType === "Home"
                              ? plan?.homeName || "Home"
                              : plan?.addressType === "PG"
                                ? plan?.apartmentName || "PG"
                                : plan?.addressType === "School"
                                  ? plan?.schoolName || "School"
                                  : plan?.addressType === "Work"
                                    ? plan?.companyName || "Company"
                                    : "Unknown"}
                          </h1>
                          <p className="addressLine2 text-truncate">
                            {plan.delivarylocation}
                          </p>
                        </div>
                      </div>

                      <div className="card-actions">
                        <div className="view-plan-btn-container">
                          <button
                            onClick={() => handleViewPlan(plan)}
                            className="view-plan-btn"
                          >
                            <span>View Plan</span>

                            <img
                              src={myplancalender}
                              alt=""
                              style={{ width: 18 }}
                            />
                          </button>
                        </div>
                        <div className="make-payment-container">
                          {/* {isUnpaidEditable && !isExpired && (
                            <div className="reminder-banner">
                              {plan.orderType === "PreOrder"
                                ? `Reserve Price valid for: ${
                                    days > 0 ? `${days}d` : ""
                                  } ${hours}h ${mins}m`
                                : `Confirm plan within: ${
                                    days > 0 ? `${days}d` : ""
                                  } ${hours}h ${mins}m`}
                            </div>
                          )} */}
                          {isUnpaidEditable && !isExpired && (
                            <div className="d-flex gap-1">
                              {/* <img
                                src={discount}
                                alt=""
                                style={{ width: "15px", height: "15px" }}
                              /> */}
                              <div className="reminder-banner">
                                {`Confirm before ${
                                  plan.session === "Lunch" ? "10AM" : "5PM"
                                }`}
                              </div>
                              {/* <div className="reminder-banner">
                                {`Before ${
                                  plan.session === "Lunch" ? "10AM" : "5PM"
                                }, pay ₹ ${(
                                  plan.slotHubTotalAmount -
                                  plan.slotTotalAmount
                                ).toFixed(0)} less
                                `}
                              </div> */}
                            </div>
                          )}
                          {isUnpaidEditable && (
                            // <button
                            //   className="pay-btn"
                            //   onClick={() => handlePayPlan(plan, "")}
                            // >
                            //   Pay
                            //   {/* {plan.orderType === "PreOrder" ? (
                            //     <div className="price-pill">
                            //       ₹{plan.slotTotalAmount?.toFixed(0)}
                            //     </div>
                            //   ) : (
                            //     <div className="price-pill">
                            //       <span className="actuall-amount">
                            //         ₹{plan.slotHubTotalAmount?.toFixed(0)}
                            //       </span>
                            //       <span className="pre-order-amount">
                            //         ₹{plan.slotTotalAmount?.toFixed(0)}
                            //       </span>
                            //     </div>
                            //   )} */}
                            //   <div className="price-pill">
                            //     {plan.slotHubTotalAmount === payableAmount ? (
                            //       <span>
                            //         ₹{plan.slotTotalAmount?.toFixed(0)}
                            //       </span>
                            //     ) : (
                            //       <div className="d-flex gap-2 align-items-center">
                            //         <span className="actuall-amount d-flex align-items-center">
                            //           ₹{plan.slotHubTotalAmount?.toFixed(0)}
                            //         </span>
                            //         <span className="pre-order-amount">
                            //           ₹{payableAmount}
                            //         </span>
                            //       </div>
                            //     )}
                            //   </div>
                            // </button>

                            <button
                              className={`pay-btn ${
                                processingPlanId === plan._id
                                  ? "processing"
                                  : ""
                              }`}
                              // onClick={() => handlePayPlan(plan, "")}
                              onClick={() => {
                                console.log("PAY BUTTON CLICKED");
                                console.log("PLAN FROM UI 👉", plan);
                                setProcessingPlanId(plan._id);
                                handlePayPlan(plan, "");
                              }}
                              disabled={processingPlanId === plan._id}
                            >
                              <div className="pay-btn-left">
                                <div className="confirm-text">
                                  {processingPlanId === plan._id ? (
                                    <>
                                      <span className="button-loader"></span>
                                      Processing
                                    </>
                                  ) : (
                                    "Confirm"
                                  )}
                                </div>
                                <div className="and-pay-text">
                                  {processingPlanId === plan._id ? "" : "& Pay"}
                                </div>
                              </div>
                              <div className="pay-btn-right">
                                {plan.slotHubTotalAmount > payableAmount ? (
                                  <div className="price-container">
                                    <span className="original-price">
                                      ₹{plan.slotHubTotalAmount?.toFixed(0)}
                                    </span>
                                    <div className="final-price-box">
                                      ₹{payableAmount}
                                    </div>
                                  </div>
                                ) : (
                                  <div
                                    className="price-container"
                                    style={{ color: "black" }}
                                  >
                                    <div className="final-price-box1">
                                      ₹{payableAmount}
                                    </div>
                                  </div>
                                )}
                              </div>
                            </button>
                          )}
                        </div>

                        {/* {isPaidEditable && (
                          <button
                            className="btn-base btn-primary"
                            onClick={async () => {
                              await axios.post(
                                "https://dailydish.in/api/user/plan/skip-cancel",
                                {
                                  planId: plan._id,
                                  userId,
                                }
                              );
                              fetchPlans();
                            }}
                          >
                            Cancel
                          </button>
                        )} */}
                        {/* {isPaidLocked && ( */}
                        {isConfirmed && (
                          // {true && (
                          <button
                            className="track-order-btn"
                            disabled={loadingTrackId === plan._id}
                            onClick={() => handleTrackOrder(plan)}
                          >
                            {loadingTrackId === plan._id ? (
                              <span>
                                <span
                                  className="button-loader"
                                  style={{
                                    borderColor: "#212121",
                                    borderBottomColor: "transparent",
                                  }}
                                ></span>
                                Wait...
                              </span>
                            ) : (
                              <>
                                <span> Track Order</span>
                                <img
                                  style={{ scale: "0.8" }}
                                  src="/Assets/tracker.svg"
                                  alt=""
                                />
                              </>
                            )}
                          </button>
                        )}
                      </div>
                    </div>
                  </>
                );
              })
            )}
          </div>
        </div>
        {/* Pay All Button - Show only if there are pending plans */}
        {/* {(() => {
          const pendingPlans = currentTabOrders.filter(
            (p) => p.status === "Pending Payment"
          );
          const totalAmount = pendingPlans.reduce(
            (sum, p) => sum + (p.payableAmount || 0),
            0
          );

          return (
            pendingPlans.length > 0 && (
              <div className="pay-all-btn-container">
                <button
                  className={`pay-all-btn ${
                    isProcessingAllPlans ? "processing" : ""
                  }`}
                  onClick={handlePayAllPlans}
                  disabled={isProcessingAllPlans}
                >
                  <div className="pay-all-btn-left">
                    {isProcessingAllPlans ? (
                      <>
                        <span className="button-loader"></span>
                        <span style={{ marginTop: "4px" }}>Processing...</span>
                      </>
                    ) : (
                      <>
                        <span>Confirm & Pay All</span>
                        <span className="pay-all-total">
                          ₹{totalAmount.toFixed(0)}
                        </span>
                      </>
                    )}
                  </div>
                </button>
              </div>
            )
          );
        })()} */}
      </div>

      {selectedPlan && (
        <ViewPlanModal
          isOpen={isModalOpen}
          onClose={closeModal}
          plan={selectedPlan}
          userId={userId}
          onPlanUpdated={onPlanUpdated}
          handlePayPlan={handlePayPlan}
          handleTrackOrder={handleTrackOrder}
          address={address}
        />
      )}

      <Modal
        className="tarck-order"
        show={trackModalVisible}
        onHide={() => {
          setTrackModalVisible(false);
          setCurrentTrackedOrder(null);
        }}
        size="lg"
        centered
      >
        {/* <Modal.Header closeButton>
          <Modal.Title>Tracking your meal</Modal.Title>
        </Modal.Header> */}
        <Modal.Body className="track-order-modal-body">
          {currentTrackedOrder &&
            (() => {
              const progressSteps = [
                "Cooking",
                "Packed",
                "On the way",
                "Delivered",
              ];
              const statusMap = { inprocess: "Cooking" };
              const currentStatus =
                statusMap[currentTrackedOrder.rawStatus] ||
                currentTrackedOrder.rawStatus;
              const currentStatusIndex = progressSteps.indexOf(currentStatus);

              // (If not found, fallback to first step)
              const displayStatus =
                progressSteps[currentStatusIndex] || progressSteps[0];

              const totalItems = (currentTrackedOrder.items || []).reduce(
                (acc, item) => acc + (item.quantity || 0),
                0,
              );

              const getStepIconStyle = (stepIndex) => ({
                backgroundColor:
                  currentStatusIndex >= stepIndex ? "#6B8E23" : "#FFFFFF",
              });
              const getIconFill = (stepIndex) =>
                currentStatusIndex >= stepIndex ? "#FFFFFF" : "#2C2C2C";
              const getConnectorFill = (stepIndex) =>
                currentStatusIndex >= stepIndex ? "#6B8E23" : "#C0C0C0";
              const phoneNumber = "7204188504";
              const message = "Hello! I need assistance.";
              const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
                message,
              )}`;
              return (
                <>
                  <div className="track-order-header">
                    <h4 className="track-order-title">Tracking your meal</h4>
                    <button
                      onClick={() => {
                        setTrackModalVisible(false);
                        setCurrentTrackedOrder(null);
                      }}
                      className="track-close-modal-btn"
                    >
                      <img src={myplancancel3} alt="" style={{ width: 24 }} />
                    </button>
                  </div>
                  <div className="trackingTopRow1">
                    <div>
                      <div className="detailsorder" style={{ fontWeight: 700 }}>
                        ORDER ID : <span>{currentTrackedOrder.orderid}</span>
                      </div>
                      <div className="detailsorder" style={{ color: "#888" }}>
                        Summary: {totalItems} items, ₹
                        {currentTrackedOrder.total}
                      </div>
                      {/* <div className="detailsorder" style={{ marginTop: 5 }}>
                        Status: <b>{displayStatus}</b>
                      </div> */}
                    </div>
                    {/* Help link if needed */}
                    <a href={whatsappLink} className="helpLinkWrapper">
                      <div className="helpLink">Need Help?</div>
                    </a>
                  </div>
                  {/* Progress bar as in your UI */}
                  <div className="progressRow">
                    {/* Step 1: In the Kitchen */}
                    <div className="stepContainer">
                      <div
                        className="stepIconCircle"
                        style={getStepIconStyle(0)}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="32"
                          height="30"
                          viewBox="0 0 32 30"
                          fill="none"
                        >
                          <path
                            d="M1 12H31M11.5 3V6M19 1.5V6M26.5 3V6M29.5 24V12H8.5V24C8.5 25.1935 8.97411 26.3381 9.81802 27.182C10.6619 28.0259 11.8065 28.5 13 28.5H25C26.1935 28.5 27.3381 28.0259 28.182 27.182C29.0259 26.3381 29.5 25.1935 29.5 24Z"
                            stroke={getIconFill(0)}
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="stepLabel">In the Kitchen</div>
                    </div>
                    <div className="stepConnector">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="37"
                        height="10"
                        viewBox="0 0 37 10"
                        fill="none"
                      >
                        <path
                          d="M7 4.3L0 0.958548V9.04145L7 5.7V4.3ZM36 5.7C36.3866 5.7 36.7 5.3866 36.7 5C36.7 4.6134 36.3866 4.3 36 4.3V5V5.7ZM6.3 5V5.7H36V5V4.3H6.3V5Z"
                          fill={getConnectorFill(1)}
                        />
                      </svg>
                    </div>
                    {/* Step 2: Packing */}
                    <div className="stepContainer">
                      <div
                        className="stepIconCircle"
                        style={getStepIconStyle(1)}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="32"
                          height="30"
                          viewBox="0 0 32 30"
                          fill="none"
                        >
                          <path
                            d="M6.09995 4.2001C6.09995 3.24532 6.47924 2.32964 7.15437 1.65451C7.8295 0.979382 8.74517 0.600098 9.69995 0.600098H22.3C23.2547 0.600098 24.1704 0.979382 24.8455 1.65451C25.5207 2.32964 25.9 3.24532 25.9 4.2001V16.8001H31.3V20.4001C31.3 21.8323 30.731 23.2058 29.7183 24.2185C28.7056 25.2312 27.3321 25.8001 25.9 25.8001H16.9V24.0001H24.1V4.2001C24.1 3.72271 23.9103 3.26487 23.5727 2.92731C23.2352 2.58974 22.7773 2.4001 22.3 2.4001H9.69995C9.22256 2.4001 8.76473 2.58974 8.42716 2.92731C8.08959 3.26487 7.89995 3.72271 7.89995 4.2001V9.9079C7.32178 9.70385 6.71307 9.59977 6.09995 9.6001V4.2001ZM19.6 13.2001H14.794C14.5584 12.5361 14.1952 11.9246 13.7248 11.4001H19.6C19.8386 11.4001 20.0676 11.4949 20.2363 11.6637C20.4051 11.8325 20.5 12.0614 20.5 12.3001C20.5 12.5388 20.4051 12.7677 20.2363 12.9365C20.0676 13.1053 19.8386 13.2001 19.6 13.2001ZM25.9 18.6001V24.0001C26.8547 24.0001 27.7704 23.6208 28.4455 22.9457C29.1207 22.2706 29.5 21.3549 29.5 20.4001V18.6001H25.9ZM11.5 6.9001C11.5 6.6614 11.5948 6.43248 11.7636 6.2637C11.9323 6.09492 12.1613 6.0001 12.4 6.0001H19.6C19.8386 6.0001 20.0676 6.09492 20.2363 6.2637C20.4051 6.43248 20.5 6.6614 20.5 6.9001C20.5 7.13879 20.4051 7.36771 20.2363 7.53649C20.0676 7.70528 19.8386 7.8001 19.6 7.8001H12.4C12.1613 7.8001 11.9323 7.70528 11.7636 7.53649C11.5948 7.36771 11.5 7.13879 11.5 6.9001ZM6.09995 11.4001C6.75515 11.4001 7.37075 11.5747 7.89995 11.8825C8.44721 11.5665 9.068 11.4002 9.69993 11.4002C10.3319 11.4002 10.9526 11.5665 11.4999 11.8825C12.0472 12.1984 12.5016 12.6529 12.8176 13.2001C13.1336 13.7474 13.2999 14.3682 13.3 15.0001V16.8001H14.2C14.4386 16.8001 14.6676 16.8949 14.8363 17.0637C15.0051 17.2325 15.1 17.4614 15.1 17.7001V25.8001C15.1 26.7549 14.7207 27.6706 14.0455 28.3457C13.3704 29.0208 12.4547 29.4001 11.5 29.4001H4.29995C3.34517 29.4001 2.4295 29.0208 1.75437 28.3457C1.07924 27.6706 0.699951 26.7549 0.699951 25.8001V17.7001C0.699951 17.4614 0.794772 17.2325 0.963555 17.0637C1.13234 16.8949 1.36126 16.8001 1.59995 16.8001H2.49995V15.0001C2.49995 14.0453 2.87924 13.1296 3.55437 12.4545C4.2295 11.7794 5.14517 11.4001 6.09995 11.4001ZM7.89995 16.8001V15.0001C7.89995 14.5227 7.71031 14.0649 7.37274 13.7273C7.03518 13.3897 6.57734 13.2001 6.09995 13.2001C5.62256 13.2001 5.16472 13.3897 4.82716 13.7273C4.48959 14.0649 4.29995 14.5227 4.29995 15.0001V16.8001H7.89995ZM9.24995 13.2559C9.53795 13.7725 9.69995 14.3683 9.69995 15.0001V16.8001H11.5V15.0001C11.5002 14.7253 11.4374 14.454 11.3166 14.2072C11.1957 13.9604 11.02 13.7445 10.8028 13.5761C10.5856 13.4078 10.3327 13.2913 10.0635 13.2358C9.79435 13.1803 9.51605 13.1872 9.24995 13.2559Z"
                            fill={getIconFill(1)}
                          />
                        </svg>
                      </div>
                      <div className="stepLabel">Packing Responsibly</div>
                    </div>
                    <div className="stepConnector">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="37"
                        height="10"
                        viewBox="0 0 37 10"
                        fill="none"
                      >
                        <path
                          d="M7 4.3L0 0.958548V9.04145L7 5.7V4.3ZM36 5.7C36.3866 5.7 36.7 5.3866 36.7 5C36.7 4.6134 36.3866 4.3 36 4.3V5V5.7ZM6.3 5V5.7H36V5V4.3H6.3V5Z"
                          fill={getConnectorFill(2)}
                        />
                      </svg>
                    </div>
                    {/* Step 3: On our way */}
                    <div className="stepContainer">
                      <div
                        className="stepIconCircle"
                        style={getStepIconStyle(2)}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="22"
                          viewBox="0 0 16 22"
                        >
                          <path
                            d="M8.20612 0.199951C4.05136 0.199951 0.646118 3.59475 0.646118 7.73835C0.646118 9.34395 1.15876 10.8362 2.02672 12.0627L7.2838 21.1505C8.02 22.1124 8.5096 21.9299 9.12196 21.1001L14.9201 11.2325C15.0371 11.0201 15.1289 10.7948 15.2092 10.5644C15.5769 9.66753 15.766 8.7076 15.7661 7.73835C15.7661 3.59475 12.362 0.199951 8.20612 0.199951ZM8.20612 3.73227C10.4439 3.73227 12.2237 5.50743 12.2237 7.73871C12.2237 9.96999 10.4435 11.7444 8.20612 11.7444C5.96872 11.7444 4.18852 9.96963 4.18852 7.73871C4.18852 5.50779 5.96908 3.73227 8.20612 3.73227Z"
                            fill={getIconFill(2)}
                          />
                        </svg>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="27"
                          height="24"
                          viewBox="0 0 27 24"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M25.7786 0.76001C24.9696 0.77801 24.1586 0.81221 23.346 0.87233L23.4713 2.86385C24.2518 2.80727 25.0336 2.7709 25.816 2.75477L25.7786 0.76001ZM21.4676 1.05521C20.2184 1.21037 18.9584 1.43141 17.7128 1.78673L18.1818 3.71669C19.3137 3.39413 20.4866 3.18569 21.6778 3.03773L21.4676 1.05521ZM15.8476 2.45489C15.4744 2.61961 15.113 2.81003 14.7662 3.02477L14.7647 3.02657L14.7626 3.02729C14.2676 3.33905 13.7459 3.73469 13.32 4.30961C13.0115 4.72613 12.7592 5.25281 12.7001 5.87561L14.5343 6.07901C14.548 5.93285 14.6229 5.73989 14.7575 5.55845H14.7582V5.55773C14.9753 5.26397 15.3008 4.99721 15.6878 4.75313L15.6892 4.75241C15.9652 4.58251 16.2525 4.43145 16.5489 4.30025L15.8476 2.45489ZM14.9033 6.96749L13.7142 8.49209C13.9961 8.74985 14.2917 8.94785 14.5772 9.11345L14.5808 9.11525L14.5844 9.11741C15.5319 9.65633 16.5089 9.96053 17.4147 10.2492L17.9352 8.33477C17.0298 8.04605 16.1763 7.76741 15.4448 7.35197C15.2352 7.23029 15.0516 7.10321 14.9033 6.96749ZM19.7039 8.87333L19.1956 10.791L19.4361 10.8659L19.7313 10.9603C20.7083 11.2781 21.6443 11.6176 22.481 12.0874L23.3298 10.3162C22.3182 9.74777 21.2681 9.37625 20.2562 9.04721L20.2533 9.04649L19.9502 8.94965L19.7039 8.87333ZM25.056 11.6453L23.7518 13.0565C24.0599 13.3903 24.2907 13.7916 24.403 14.2064L24.4037 14.2085L24.4044 14.2118C24.5384 14.696 24.5387 15.2655 24.434 15.8408L26.2426 16.2267C26.3902 15.4145 26.414 14.5228 26.1713 13.6426C25.96 12.8643 25.5568 12.1882 25.056 11.6453ZM23.8025 17.0432C23.6029 17.2534 23.3827 17.443 23.1452 17.6091H23.1444C22.4964 18.0648 21.7448 18.4083 20.9463 18.7035L21.5417 20.5913C22.4151 20.2684 23.3118 19.8724 24.1499 19.2827L24.1521 19.2809L24.1532 19.2802C24.4973 19.0391 24.8156 18.7632 25.1032 18.4569L23.8025 17.0432ZM19.2521 19.2352C18.0954 19.5462 16.9132 19.7831 15.7166 19.984L15.9988 21.9564C17.2304 21.7494 18.467 21.5021 19.696 21.1716L19.2521 19.2352ZM13.9162 20.2562C12.7116 20.4207 11.5006 20.555 10.286 20.6695L10.4451 22.6574C11.6784 22.5414 12.914 22.405 14.1477 22.2362L13.9162 20.2562ZM8.46039 20.826C7.24323 20.9225 6.02319 21.001 4.80207 21.0672L4.89423 23.0602C6.12723 22.9936 7.36131 22.914 8.59503 22.8161L8.46039 20.826ZM2.96715 21.1572C2.23527 21.1914 1.50159 21.2195 0.766113 21.2454L0.826594 23.2402C1.56667 23.2148 2.3066 23.1852 3.04635 23.1516L2.96715 21.1572Z"
                            fill={getIconFill(2)}
                          />
                        </svg>
                      </div>
                      <div className="stepLabel">On our way</div>
                    </div>
                    <div className="stepConnector">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="40"
                        height="10"
                        viewBox="0 0 40 10"
                        fill="none"
                      >
                        <path
                          d="M7 4.3L0 0.958548V9.04145L7 5.7V4.3ZM32.2667 5C32.2667 7.06186 33.9381 8.73333 36 8.73333C38.0619 8.73333 39.7333 7.06186 39.7333 5C39.7333 2.93814 38.0619 1.26667 36 1.26667C33.9381 1.26667 32.2667 2.93814 32.2667 5ZM6.3 5V5.7H36V5V4.3H6.3V5Z"
                          fill={getConnectorFill(3)}
                        />
                      </svg>
                    </div>
                    {/* Step 4: At your door */}
                    <div className="stepContainer">
                      <div
                        className="stepIconCircle"
                        style={getStepIconStyle(3)}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="30"
                          height="28"
                          viewBox="0 0 30 28"
                          fill="none"
                        >
                          <path
                            d="M12 0.974609C12.3146 0.974609 12.6167 1.02361 12.9062 1.12012C13.1233 1.19252 13.3345 1.29163 13.5391 1.41895L13.7412 1.55566L17.8271 4.62988C18.2083 4.91578 18.3942 5.24611 18.4053 5.62207C18.4167 6.01501 18.3164 6.34896 18.1074 6.62793C17.8986 6.90655 17.6135 7.08782 17.2471 7.17188C16.8949 7.25265 16.5168 7.15905 16.1074 6.86816L12.0605 3.79492L12 3.75L11.9404 3.79492L2.94043 10.5449L2.90039 10.5752V24.2246H7.5C7.89976 24.2246 8.23067 24.3596 8.49902 24.6279C8.76722 24.8962 8.90133 25.2265 8.90039 25.625C8.8994 26.0238 8.76463 26.3546 8.49707 26.624C8.22986 26.8931 7.8995 27.0273 7.5 27.0254H3C2.20181 27.0254 1.52146 26.7421 0.953125 26.1738C0.384772 25.6055 0.100605 24.9243 0.0996094 24.125V10.625C0.0996094 10.1656 0.203144 9.73044 0.40918 9.31934C0.615186 8.90847 0.898147 8.57092 1.25879 8.30566L1.25977 8.30469L10.2588 1.55566C10.526 1.36136 10.8044 1.21663 11.0938 1.12012C11.3833 1.02361 11.6854 0.974609 12 0.974609ZM21 19.7246C22.3412 19.7246 23.6386 19.8986 24.8926 20.2461C26.1463 20.5935 27.3444 21.1014 28.4854 21.7715V21.7725C28.9207 22.0385 29.2658 22.3953 29.5205 22.8438C29.775 23.2918 29.9013 23.7683 29.9004 24.2744V24.2754C29.9003 25.0495 29.6351 25.6989 29.1045 26.2295C28.5739 26.7601 27.9245 27.0253 27.1504 27.0254H14.8496C14.0755 27.0253 13.4261 26.7601 12.8955 26.2295C12.3649 25.6989 12.0997 25.0495 12.0996 24.2754C12.0996 23.7681 12.227 23.2909 12.4814 22.8428C12.7362 22.3943 13.0803 22.0375 13.5146 21.7725L13.5137 21.7715C14.6558 21.1013 15.8545 20.5936 17.1084 20.2461C18.3624 19.8986 19.6598 19.7246 21 19.7246ZM21 22.5254C19.9669 22.5254 18.9587 22.6513 17.9756 22.9033C16.992 23.1555 16.0584 23.5337 15.1758 24.0381L14.8486 24.2246H27.1514L26.8242 24.0381C25.9416 23.5337 25.008 23.1555 24.0244 22.9033C23.0413 22.6513 22.0331 22.5254 21 22.5254ZM21 9.22461C22.2238 9.22461 23.2612 9.65178 24.1172 10.5078C24.9732 11.3638 25.4004 12.4012 25.4004 13.625C25.4004 14.8488 24.9732 15.8862 24.1172 16.7422C23.2612 17.5982 22.2238 18.0254 21 18.0254C19.7762 18.0254 18.7388 17.5982 17.8828 16.7422C17.0268 15.8862 16.5996 14.8488 16.5996 13.625C16.5996 12.4012 17.0268 11.3638 17.8828 10.5078C18.7388 9.65178 19.7762 9.22461 21 9.22461ZM21 12.0254C20.5498 12.0254 20.168 12.1787 19.8613 12.4863C19.5548 12.7939 19.4014 13.1759 19.4004 13.625C19.3994 14.0744 19.5528 14.4571 19.8613 14.7656C20.1698 15.074 20.5517 15.2266 21 15.2246C21.4502 15.2246 21.833 15.0713 22.1406 14.7637C22.4481 14.4561 22.6006 14.0742 22.5996 13.625C22.5986 13.1759 22.4452 12.7939 22.1387 12.4863C21.832 12.1787 21.4502 12.0254 21 12.0254Z"
                            fill={getIconFill(3)}
                            stroke={
                              getIconFill(3) === "#FFFFFF" ? "#FFFFFF" : "white"
                            }
                            strokeWidth="0.2"
                          />
                        </svg>
                      </div>
                      <div className="stepLabel">At your door</div>
                    </div>
                  </div>
                  <div className="etaText" style={{ marginTop: 16 }}>
                    Your meal is scheduled for{" "}
                    <span style={{ fontWeight: "bold", color: "black" }}>
                      {sessionDetails === "Lunch"
                        ? "12:00 - 1:30 PM"
                        : sessionDetails === "Dinner"
                          ? "7:30 - 8:30 PM"
                          : ""}
                    </span>
                  </div>
                </>
              );
            })()}
        </Modal.Body>
      </Modal>
      {/* Quick Answers modal (opened from header pending icon) */}
      <Modal
        show={showQuickAnswers}
        onHide={() => setShowQuickAnswers(false)}
        centered
        dialogClassName="quick-answers-modal"
        style={{ zIndex: "10000" }}
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: 14, color: "#222", lineHeight: 1.5 }}>
            🥗 Meal Planning — quick answers 📅🚚
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
          <div style={{ fontSize: 14, color: "#222", lineHeight: 1.5 }}>
            <h5
              style={{
                fontFamily: "'Inter', sans-serif",
                fontWeight: "bold",
                fontSize: "12px",
                marginBottom: "4px",
                marginTop: "16px",
              }}
            >
              1. How do daily plans work?
            </h5>
            <p
              style={{
                fontStyle: "italic",
                fontSize: "12px",
                marginBottom: "16px",
              }}
            >
              We organize your meals into <strong>Today, Tomorrow</strong>, and{" "}
              <strong>Upcoming</strong> lists. You can plan ahead for the whole
              week, but nothing is ordered until you tap "
              <strong>Confirm & Pay</strong>" for each specific day.
            </p>

            <h5
              style={{
                fontFamily: "'Inter', sans-serif",
                fontWeight: "bold",
                fontSize: "12px",
                marginBottom: "4px",
                marginTop: "16px",
              }}
            >
              2. Why confirm early?
            </h5>
            <p
              style={{
                fontStyle: "italic",
                fontSize: "12px",
                marginBottom: "16px",
              }}
            >
              Confirming early guarantees your meal. We start cooking based on
              confirmed orders to ensure freshness and zero waste. Once the
              cutoff time passes, we stop taking orders for that meal—no
              exceptions.
            </p>

            <h5
              style={{
                fontFamily: "'Inter', sans-serif",
                fontWeight: "bold",
                fontSize: "12px",
                marginBottom: "4px",
                marginTop: "16px",
              }}
            >
              3. What are the cutoff times?
            </h5>
            <p
              style={{
                fontStyle: "italic",
                fontSize: "12px",
                marginBottom: "16px",
              }}
            >
              <strong>Lunch:</strong> Confirm by <strong>10:00 AM</strong>{" "}
              (Delivered <strong>12:00–1:30 PM</strong>)<br />
              <strong>Dinner:</strong> Confirm by <strong>5:00 PM</strong>{" "}
              (Delivered <strong>7:30–8:30 PM</strong>)<br />
              After these times, ordering for that meal is closed.
            </p>

            <h5
              style={{
                fontFamily: "'Inter', sans-serif",
                fontWeight: "bold",
                fontSize: "12px",
                marginBottom: "4px",
                marginTop: "16px",
              }}
            >
              4. What does "View Plan" show?
            </h5>
            <p
              style={{
                fontStyle: "italic",
                fontSize: "12px",
                marginBottom: "16px",
              }}
            >
              "View Plan" is your checkout screen. It shows exactly what's in
              your meal, the total bill, any discounts, and your delivery
              address. This is also where you apply your Wallet Credits before
              paying.
            </p>

            <h5
              style={{
                fontFamily: "'Inter', sans-serif",
                fontWeight: "bold",
                fontSize: "12px",
                marginBottom: "4px",
                marginTop: "16px",
              }}
            >
              5. What do the statuses mean?
            </h5>
            <p
              style={{
                fontStyle: "italic",
                fontSize: "12px",
                marginBottom: "16px",
              }}
            >
              <strong>Pending:</strong> You planned this meal but haven't paid.
              It is not ordered yet.
              <br />
              <strong>Confirmed:</strong> You've paid. Your meal is locked in
              and will be delivered.
              <br />
              <strong>Skipped:</strong> You removed this plan or missed the
              cutoff.
            </p>

            <h5
              style={{
                fontFamily: "'Inter', sans-serif",
                fontWeight: "bold",
                fontSize: "12px",
                marginBottom: "4px",
                marginTop: "16px",
              }}
            >
              6. Can I cancel after confirming?
            </h5>
            <p
              style={{
                fontStyle: "italic",
                fontSize: "12px",
                marginBottom: "16px",
              }}
            >
              Once you confirm, we start preparing your order almost
              immediately.
              <br />
              <br />
              <strong>Before Cutoff:</strong> You can't self-cancel in the app
              (yet), but please contact Customer Support. We handle these
              requests case-by-case.
              <br />
              <strong>After Cutoff:</strong> Cancellations are generally not
              possible as food preparation has begun.
            </p>

            <h5
              style={{
                fontFamily: "'Inter', sans-serif",
                fontWeight: "bold",
                fontSize: "12px",
                marginBottom: "4px",
                marginTop: "16px",
              }}
            >
              7. What happens if I "Skip" a plan?
            </h5>
            <p
              style={{
                fontStyle: "italic",
                fontSize: "12px",
                marginBottom: "16px",
              }}
            >
              Skipping tells us you definitely don't want that meal, which helps
              us forecast our kitchen stock better.
              <br />
              <br />
              <strong>Note:</strong> If you don't confirm a "Pending" plan by
              the cutoff time, it gets skipped automatically. You won't be
              charged.
            </p>

            <h5
              style={{
                fontFamily: "'Inter', sans-serif",
                fontWeight: "bold",
                fontSize: "12px",
                marginBottom: "4px",
                marginTop: "16px",
              }}
            >
              8. How do discounts work?
            </h5>
            <p
              style={{
                fontStyle: "italic",
                fontSize: "12px",
                marginBottom: "16px",
              }}
            >
              Discounts apply automatically where eligible.
              <br />
              <br />
              Get <strong>₹75 off</strong> accross your <strong>first 3</strong>{" "}
              orders.
              <br />
              <br />
              You'll see the discount breakdown inside "View Plan" before you
              pay.
            </p>

            <h5
              style={{
                fontFamily: "'Inter', sans-serif",
                fontWeight: "bold",
                fontSize: "12px",
                marginBottom: "4px",
                marginTop: "16px",
              }}
            >
              9. What if I forget to confirm?
            </h5>
            <p
              style={{
                fontStyle: "italic",
                fontSize: "12px",
                marginBottom: "16px",
              }}
            >
              Nothing bad happens! Your plan stays "Pending" until the cutoff
              passes, then it simply disappears. You are never charged unless
              you explicitly hit "Confirm & Pay".
            </p>

            <h5
              style={{
                fontFamily: "'Inter', sans-serif",
                fontWeight: "bold",
                fontSize: "12px",
                marginBottom: "4px",
                marginTop: "16px",
              }}
            >
              10. Where is my refund?
            </h5>
            <p
              style={{
                fontStyle: "italic",
                fontSize: "12px",
                marginBottom: "16px",
              }}
            >
              If a refund is approved by support for any reason, the money is
              refunded instantly to your <strong>DailyDish Wallet</strong>. You
              can use it for your next meal.
            </p>

            <h5
              style={{
                fontFamily: "'Inter', sans-serif",
                fontWeight: "bold",
                fontSize: "12px",
                marginBottom: "4px",
                marginTop: "16px",
              }}
            >
              11. Where can I see past orders?
            </h5>
            <p
              style={{
                fontStyle: "italic",
                fontSize: "12px",
                marginBottom: "16px",
              }}
            >
              Delivered meals move to My Orders / Order History automatically.
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer
          style={{
            display: "flex",
            justifyContent: "center",
            borderTop: "none",
            paddingTop: "0",
          }}
        >
          <button
            style={{
              backgroundColor: "#6B8E23",
              border: "none",
              color: "white",
              padding: "10px 24px",
              borderRadius: "6px",
              cursor: "pointer",
              fontSize: "16px",
              fontWeight: "600",
              width: "120px",
            }}
            onClick={() => setShowQuickAnswers(false)}
          >
            Got it
          </button>
        </Modal.Footer>
      </Modal>

      <BottomNav />

      {/* Pay All Button - Fixed at bottom */}
      {/* {(() => {
        const allPendingPlans = plans.filter((p) => p.status === "Pending Payment");
        if (allPendingPlans.length === 0) return null;

        const totalAmount = allPendingPlans.reduce(
          (sum, plan) => sum + (plan.payableAmount || plan.slotTotalAmount || 0),
          0
        );

        return (
          <div className="pay-all-btn-container">
            <div className="pay-all-btn-content">
              <div className="pay-all-info">
                <div className="pay-all-label">Confirm & Pay All</div>
                <div className="pay-all-total">₹{totalAmount.toFixed(0)}</div>
                <div className="pay-all-count">{allPendingPlans.length} plan{allPendingPlans.length > 1 ? "s" : ""}</div>
              </div>
              <button
                className={`pay-all-btn ${isProcessingAllPlans ? "processing" : ""}`}
                onClick={handlePayAllPlans}
                disabled={isProcessingAllPlans}
              >
                <div className="pay-all-btn-text">
                  {isProcessingAllPlans ? (
                    <>
                      <span className="button-loader"></span>
                      Processing...
                    </>
                  ) : (
                    <>
                      <span className="pay-all-btn-icon">✓</span>
                      Confirm All
                    </>
                  )}
                </div>
              </button>
            </div>
          </div>
        );
      })()} */}
    </div>
  );
};

export default MyPlan;
